import {
  DATA_TYPES,
  SECTIONS,
  NOTIFICATION_TYPES,
  DRAWER_PLACEMENTS,
  OPERATIONS,
} from "../../../../config/constants";
import {
  GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT,
  GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT, GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT,
  GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT,
  TABLE_SETUP_COMPONENT_ADVANCED_OPTIONS_TOGGLE,
  TABLE_SETUP_HIDE_SYSTEM_FIELDS,
} from "../../../../config/consts/appsettings";
import PageHead from "../../../layout/PageHead";
import {
  Tabs,
  Select,
  Button,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Checkbox,
  InputNumber,
  Menu,
  Empty,
  Spin,
  Space,
  Popconfirm,
  AutoComplete,
  Dropdown,
  Drawer,
  Pagination,
  List,
  FormInstance,
  InputRef,
  Modal,
  Upload,
  UploadFile,
  MenuProps,
  Tooltip, RadioChangeEvent,
} from "antd";
import "./TableSetup.css";
import {
  PlusOutlined,
  SyncOutlined,
  CheckOutlined,
  TableOutlined,
  EyeOutlined,
  ExportOutlined,
  DeleteOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
  DownOutlined,
  DownloadOutlined,
  UploadOutlined,
  CopyOutlined,
  EditOutlined,
  MoreOutlined,
  KeyOutlined,
} from "@ant-design/icons";
import * as AntDesignIcons from "@ant-design/icons";
import React, {
  Suspense,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import { GetTablesRequest } from "../../../../models/tables/GetTablesRequest";
import { GetFieldsRequest } from "../../../../models/fields/GetFieldsRequest";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { CreateTableRequest } from "../../../../models/tables/CreateTableRequest";
import { UpdateTableRequest } from "../../../../models/tables/UpdateTableRequest";
import { UpdateFieldRequest } from "../../../../models/fields/UpdateFieldRequest";
import { CreateFieldRequest } from "../../../../models/fields/CreateFieldRequest";
import styles from "../table-setup/TableSetup.module.css";
import { useLocation, useSearchParams } from "react-router-dom";
import Table, { ColumnsType } from "antd/lib/table";
import Translations from "./components/Translations";
import References from "./components/References";
import { DeleteTableRequest } from "../../../../models/tables/DeleteTableRequest";
import { DeleteFieldRequest } from "../../../../models/fields/DeleteFieldRequest";
import DatabaseService from "../../../../services/databases/DatabaseService";
import { MenuInfo } from "rc-menu/lib/interface";
import { useTranslation } from "react-i18next";
import Datatable from "../../../shared/components/Datatable";
import saveAs from "file-saver";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import history from "../../../shared/utils/HistoryUtil";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import EditableTable from "./components/EditableTable";
import { UploadChangeParam } from "antd/lib/upload";
import { useDispatch, useSelector } from "react-redux";
import ApplicationService from "../../../../services/application/ApplicationService";
import UsersService from "../../../../services/admin/UsersService";
import { FIELD_MAX_LENGTH } from "../../../../config/consts/validations";
import { red } from "@ant-design/colors";
import { ROUTES } from "../../../../config/consts/routes";
import { Radio } from 'antd';
import tablesService from "../../../../services/tables/TablesService";
import tableIcon from "../../../../img/grid.svg";
import viewIcon from "../../../../img/doubleBox.svg";
import ReferenceService from "../../../../services/references/ReferencesService";
import { setExtractionResultTableParams, setGroupCode, setOperation, setEntity } from "../../../../redux/actions";
import { IconErrorBoundary } from "../../../shared/components/icon-error/IconErrorBoundary";
import { System } from "../../../../models/system/System";
import SystemService from "../../../../services/sytem/SystemService";
import { FieldType } from "../../../../models/fields/FieldType";
import { FieldSubType } from "../../../../models/fields/FieldSubType";

const { TabPane } = Tabs;

const EditableContext = React.createContext<FormInstance<any> | null>(null);

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.configuration.name,
  },
  {
    path: ROUTES.configuration.tableSetup.route,
    breadcrumbName: ROUTES.configuration.tableSetup.name,
  },
];

const TableSetup = () => {
  const { t, i18n } = useTranslation("translations");

  const location = useLocation();
  const dispatch = useDispatch();

  const [viewTablePageIndex, setViewTablePageIndex] = useState(1);
  const [viewTablePageSize, setViewTablePageSize] = useState(20);


  const [searchParams, setSearchParams] = useSearchParams();
  const [drawerForm] = Form.useForm();
  const [exportForm] = Form.useForm();
  const [recreateForm] = Form.useForm();

  const tableRef = useRef<any>();
  const databaseRef = useRef<any>();

  const { Option } = Select;
  const { TextArea } = Input;

  const [defaultDatabase, setDefaultDatabase] = useState(null);

  const [isFieldsLoading, setIsFieldsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);

  const [selectedTable, setSelectedTable] = useState<any>(null);
  const [selectedField, setSelectedField] = useState<any>(null);
  const [selectedValidationField, setSelectedValidationField] =
    useState<any>(null);

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [databases, setDatabases] = useState<any>([]);
  const [preferences, setPreferences] = useState<any>([]);
  const [referenceValidationTypes, setReferenceValidationTypes] = useState<any>([]);
  const [referenceAllowedValues, setReferenceAllowedValues] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();

  const [fieldTypes, setFieldTypes] = useState<FieldType[]>([]);
  const [fieldSubtypes, setFieldSubtypes] = useState<FieldSubType[]>([]);

  const [dependentColumns, setDependentColumns] = useState<any[]>([]);
  const [dependentType, setDependentType] = useState<any>();
  
  const [formatOptions, setFormatOptions] = useState<any[]>([]);


  const [sourceKeys, setSourceKeys] = useState<any>([]);

  const [selectedViewDataGroupCode, setSelectedViewDataGroupCode] =
    useState<any>("");
  const [selectedViewDataRowsToShow, setSelectedViewDataRowsToShow] =
    useState<any>(100);
  const [selectedExportViewDataGroupCode, setSelectedExportViewDataGroupCode] =
    useState<any>("");
  const [
    selectedExportViewDataRowsToShow,
    setSelectedExportViewDataRowsToShow,
  ] = useState<any>(100);
  const [isTableViewDataLoading, setIsTableViewDataLoading] =
    useState<boolean>(false);

  const [selectedRecreateTableEntity, setSelectedRecreateTableEntity] =
    useState<any>("");

  const [selectedRecreateTableOperation, setSelectedRecreateTableOperation] =
    useState<any>("");

  const [recreateTableName, setRecreateTableName] = useState<any>("");
  const [recreateTableDatabase, setRecreateTableDatabase] = useState<any>("");
  const [recreateTableSchema, setRecreateTableSchema] = useState<any>("");

  const [recreateSelectedSourceEntity, setRecreateSelectedSourceEntity] =
    useState<any>("");
  const [recreateSelectedSourceOperation, setRecreateSelectedSourceOperation] =
    useState<any>("");
  const [recreateSelectedSourceTable, setRecreateSelectedSourceTable] =
    useState<any>("");

  const [recreateSelectedSourceTables, setRecreateSelectedSourceTables] =
    useState<any>([]);

  const [tables, setTables] = useState<any>([]);
  const [fields, setFields] = useState<any>([]);
  const [fixedFields, setFixedFields] = useState<any>([]);
  const [fixedFieldsRender, setFixedFieldsRender] = useState<any>([]);
  const [draggableFields, setDraggableFields] = useState<any>([]);

  const [updateTableAllowed, setUpdateTableAllowed] = useState<boolean>(false);
  const [updateFieldAllowed, setUpdateFieldAllowed] = useState<boolean>(false);

  const [createTableLoading, setCreateTableLoading] = useState<boolean>(false);
  const [updateTableLoading, setUpdateTableLoading] = useState<boolean>(false);
  const [updateFieldLoading, setUpdateFieldLoading] = useState<boolean>(false);

  const [triggerEditFieldsDrawer, setTriggerEditFieldsDrawer] =
    useState<boolean>(false);

  const [isEditFieldsSaveLoading, setIsEditFieldsSaveLoading] =
    useState<boolean>(false);

  const [
    uploadRecreateTableFromExcelDrawerEnabled,
    setUploadRecreateTableFromExcelDrawerEnabled,
  ] = useState<boolean>(false);
  const [
    uploadRecreateTableFromTableDrawerEnabled,
    setUploadRecreateTableFromTableDrawerEnabled,
  ] = useState<boolean>(false);
  const [
    downloadRecreateTableAsExcelDrawerEnabled,
    setDownloadDownloadRecreateTableAsExcelDrawerEnabled,
  ] = useState<boolean>(false);
  const [
    downloadRecreateTableAsEmptyExcelDrawerEnabled,
    setDownloadDownloadRecreateTableAsEmptyExcelDrawerEnabled,
  ] = useState<boolean>(false);

  const [recreateTableSaveTriggered, setRecreateTableSaveTriggered] =
    useState<boolean>(false);

  const [
    recreateTableSaveAndCloseTriggered,
    setRecreateTableSaveAndCloseTriggered,
  ] = useState<boolean>(false);



  const [newTranslationDrawerEnabled, setNewTranslationDrawerEnabled] =
    useState(false);
  const [
    downloadTranslationDrawerEnabled,
    setDownloadTranslationDrawerEnabled,
  ] = useState(false);
  const [
    downloadTranslationTemplateDrawerEnabled,
    setDownloadTranslationTemplateDrawerEnabled,
  ] = useState(false);
  const [uploadTranslationDrawerEnabled, setUploadTranslationDrawerEnabled] =
    useState(false);

  const [newReferenceDrawerEnabled, setNewReferenceDrawerEnabled] =
    useState(false);
  const [downloadReferenceDrawerEnabled, setDownloadReferenceDrawerEnabled] =
    useState(false);
  const [
    downloadReferenceTemplateDrawerEnabled,
    setDownloadReferenceTemplateDrawerEnabled,
  ] = useState(false);
  const [uploadReferenceDrawerEnabled, setUploadReferenceDrawerEnabled] =
    useState(false);
  const [showViewDrawer, setShowViewDrawer] = useState(false);
  const [showViewExportDrawer, setShowViewExportDrawer] = useState(false);
  const [showEditFieldsDrawer, setShowEditFieldsDrawer] = useState(false);
  const [tableViewData, setTableViewData] = useState<any>([]);
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);
  const [triggerDatabaseRef, setTriggerDatabaseRef] = useState<boolean>(false);
  const [newTableEdit, setNewTableEdit] = useState<boolean>(false);

  // region Validations

  const [validateDescription, setValidateDescription] = useState(false);
  const [validateMaxLength, setValidateMaxLength] = useState(false);
  const [validateMaxLengthOverride, setValidateMaxLengthOverride] = useState(false);

  // endregion

  const [columns, setColumns] = useState<ColumnsType<DataType>>([]);

  const [isDirty, setIsDirty] = useState<any>(false);
  const [isEditFieldsDirty, setIsEditFieldsDirty] = useState<any>(false);
  const [currentActiveKey, setCurrentActiveKey] = useState<any>(
    searchParams.get("tab")
  );
  const [additionalOptionsVisible, setAdditionalOptionsVisible] =
    useState(false);

  const [recreateTablePopConfirmOpen, setRecreateTablePopConfirmOpen] = useState<boolean>(false);

  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [recreateSelectedSource, setRecreateSelectedSource] =
    useState<any>("blankTable");
  const [recreateSelectedUploadFile, setRecreateSelectedUploadFile] =
    useState<any>(null);
  const [recreateTableFields, setRecreateTableFields] = useState<any>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const [recreateTableDataSource, setRecreateTableDataSource] = useState<any>([
    {
      key: 9,
      fieldName: "",
      datatype: "",
      maxLength: 0,
      autotrim: false,
      precision: 0,
      scale: 0,
      label: "",
      description: "",
      owner: "",
      whoToSolve: "",
      deltaCollection: "ALL",
      mandatory: false,
      position: 1,
      nonEditable: false,
    },
  ]);

  const { profile, userHasPermissions, extractionResultTableParams } = useSelector((state: any) => ({
    profile: state.profile,
    userHasPermissions: state.userHasPermissions,
    extractionResultTableParams: state.extractionResultTableParams,
  }));

  const [systems, setSystems] = useState<System[]>([]);

  useEffect(() => {
    if (extractionResultTableParams) {
      dispatch(setGroupCode(extractionResultTableParams.groupCode));
      dispatch(setEntity(extractionResultTableParams.entityId));
      dispatch(setOperation(extractionResultTableParams.operation));
    }
  }, [extractionResultTableParams]);
  
  

  useEffect(() => {
    if (!isDirty) return;

    const unblock = history.block((tx: any) => {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        unblock();
        tx.retry();
      } else {
        // searchParams.set("tab", location.pathname.split("?tab=")[1]);
        // setSearchParams(searchParams);
        window.onbeforeunload = () => true;
      }
    });

    return () => {
      unblock();
    };
  }, [isDirty]);

  useEffect(() => {
    if (selectedTable) {
      if (updateTableAllowed) {
        setIsDirty(true);
        return;
      }
    }
    if (selectedField) {
      if (updateFieldAllowed) {
        setIsDirty(true);
        return;
      }
    }
    setIsDirty(false);
  }, [selectedTable, selectedField, updateTableAllowed, updateFieldAllowed]);

  const handleSaveAndClose = () => {
    let dataRows = recreateTableDataSource;
    if (dataRows[dataRows.length - 1] && dataRows[dataRows.length - 1].fieldName === "") {
      dataRows.pop();
    }

    const hasKeys = dataRows.some((item: any) => item.isKey);
    const hasNoAllDeltaCollection = dataRows
      .every((item: any) => item.deltaCollection?.toUpperCase() !== "ALL" && item.deltaCollection !== "");

    if (selectedOperation === OPERATIONS.IMPORT) {
      if (!newTableEdit) {
        if (!hasKeys) {
          Modal.confirm({
            title: "Warning",
            content: "You have not selected any keys for this import table. Datashaper will not be able to assign the unique code for each record automatically. This means you will need to map the code manually. Are you sure you want to continue?",
            onOk() {
              setRecreateTableSaveAndCloseTriggered(true);
            },
          });
        } else if (isCheckboxChanged && sourceKeys.length > 0) {
          Modal.confirm({
            title: "Warning",
            content: "Changing the keys on an import table will replace the existing code mapping and remove data in legacy from previous runs. Are you sure you wish to proceed?",
            onOk() {
              setRecreateTableSaveAndCloseTriggered(true);
            },
          });
        }
        else {
          setRecreateTableSaveAndCloseTriggered(true);
        }
      } else {
        setRecreateTableSaveAndCloseTriggered(true);
      }
    }
    else if (selectedOperation === OPERATIONS.LEGACY) {
      if (hasNoAllDeltaCollection) {
        Modal.confirm({
          title: "Warning",
          content: "You have not set delta collection to 'ALL' for any field. This way, processing legacy will not update anything as no changes are tracked. Are you sure you want to proceed?",
          onOk() {
            setRecreateTableSaveTriggered(true);
          },
        });
      }
      else {
        setRecreateTableSaveAndCloseTriggered(true);
      }
    }
    else {
      setRecreateTableSaveAndCloseTriggered(true);
    }
  }

  const handleSave = () => {

    let dataRows = [...recreateTableDataSource];
    if (dataRows[dataRows.length - 1] && dataRows[dataRows.length - 1].fieldName === "") {
      dataRows.pop();
    }

    const hasKeys = dataRows.some((item: any) => item.isKey);
    const hasNoAllDeltaCollection = dataRows.every((item: any) => item.deltaCollection?.toUpperCase() !== "ALL" && item.deltaCollection !== "");
    if (selectedOperation === OPERATIONS.IMPORT) {
      if (!newTableEdit) {
        if (!hasKeys) {
          Modal.confirm({
            title: "Warning",
            content: "You have not selected any keys for this import table. Datashaper will not be able to assign the unique code for each record automatically. This means you will need to map the code manually. Are you sure you want to continue?",
            onOk() {
              setRecreateTableSaveTriggered(true);
            },
          });
        } else if (isCheckboxChanged && sourceKeys.length > 0) {
          Modal.confirm({
            title: "Warning",
            content: "Changing the keys on an import table will replace the existing code mapping and remove data in legacy from previous runs. Are you sure you wish to proceed?",
            onOk() {
              setRecreateTableSaveTriggered(true);
            },
          });
        }
        else {
          setRecreateTableSaveTriggered(true);
        }
      } else {
        setRecreateTableSaveTriggered(true);
      }
    }
    else if (selectedOperation === OPERATIONS.LEGACY) {
      if (hasNoAllDeltaCollection) {
        Modal.confirm({
          title: "Warning",
          content: "You have not set delta collection to 'ALL' for any field. This way, processing legacy will not update anything as no changes are tracked. Are you sure you want to proceed?",
          onOk() {
            setRecreateTableSaveTriggered(true);
          },
        });
      }
      else {
        setRecreateTableSaveAndCloseTriggered(true);
      }
    }
    else {
      setRecreateTableSaveTriggered(true);
    }
  };

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const clonedListItems = JSON.parse(JSON.stringify(draggableFields));
    const [reorderedItem] = clonedListItems.splice(result.source.index, 1);
    clonedListItems.splice(result.destination.index, 0, reorderedItem);

    const maxPosition =
      fixedFields.length > 0
        ? Math.max(...fixedFields.map((item: any) => item.position))
        : 0;

    clonedListItems.forEach((element: any, index: any) => {
      element.position = maxPosition + index + 1;
    });

    const finalListItems = [...fixedFields, ...clonedListItems];

    TablesService.updateFieldPositions(
      finalListItems.map((x: any) => ({
        id: x.id,
        position: x.position,
      }))
    );

    setFields(finalListItems);
  };

  useEffect(() => {
    document.title = ROUTES.configuration.tableSetup.name;
  }, []);

  useEffect(() => {
    if (!isDirty && currentActiveKey) {
      onTabChange(currentActiveKey);
    }
  }, [isDirty, currentActiveKey]);
  

  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
    DatabaseService.getAll().then((response: any) => {
      const data = response.data;
      setDatabases(data);
    });

    ApplicationService.getPreferences().then((response: any) => {
      const data = response.data;
      setPreferences(data);
    });
  }, []);

  useEffect(() => {
    TablesService.getFieldTypes().then((response) => {
      setFieldTypes(response.data);
    });
  }, []);

  useEffect(() => {
    TablesService.getFieldSubtypes().then((response: any) => {
      setFieldSubtypes(response.data);
    });
  }, []);

  useEffect(() => {
      const selectedFieldType = fieldTypes.find(x => x.id === selectedField?.typeId);
      if (selectedFieldType?.dependentTypeId) {
       setDependentType(fieldTypes.find(x => x.id === selectedFieldType?.dependentTypeId));
        const dependentFields = fields
            .filter(f => f.typeId === selectedFieldType.dependentTypeId)
            .map(f => ({ label: f.name, value: f.id }));
        setDependentColumns(dependentFields);
      } else {
        setDependentType(undefined);
        setDependentColumns([]);
      }
  }, [selectedField?.typeId, fieldTypes, fields]);


  useEffect(() => {
    if (selectedField?.typeId) {
      const subtypes = fieldSubtypes.filter(x => x.typeId === selectedField.typeId)
          .map(x => ({ label: x.label, value: x.id }));
      setFormatOptions(subtypes);
    }
  }, [selectedField?.typeId, fieldTypes, fieldSubtypes, selectedField?.id]);
  
  

  const onSelectedCountryColumnChange = (value: number) => {
    setSelectedField({ ...selectedField, subtypeCountryFieldId: value });
  };


  const onSelectedFormatChange = (value: string) => {
    setSelectedField({ ...selectedField, subtypeFormatId: value });
  };

  useEffect(() => {
    setTables([]);
    setFields([]);
    setSelectedTable(undefined);
    setSelectedField(undefined);
    checkPreferences();

    if (selectedEntity && selectedOperation) {
      setIsTableLoading(true);
      const model: GetTablesRequest = {
        entityId: selectedEntity,
        operationId: selectedOperation,
        groupCode: "",
      };
      TablesService.getTables(model).then((response: any) => {
        const data = response.data.sort(function (a: any, b: any) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          return 0;
        });
        setTables(data);
        setIsTableLoading(false);

        if (extractionResultTableParams) {
          setSelectedTable(data.find((x: any) => x.name === extractionResultTableParams.tableName));
          dispatch(setExtractionResultTableParams(null));
        }
        else if (data.length === 1) {
          setSelectedTable(data.filter((x: any) =>
            selectedOperation === OPERATIONS.IMPORT && selectedGroupCode
              ? x.groupCode === selectedGroupCode
              : x.groupCode === x.groupCode
          )[0]);
        }
      });

      ReferenceService.getAllReferences().then((response: any) => {
        const data = response.data;
        setReferenceValidationTypes(
          data.map((x: any) => x.validationType).filter(onlyUnique)
        );
        setReferenceAllowedValues(
          data.map((x: any) => x.allowedValue).filter(onlyUnique)
        );
      });
    }
  }, [selectedEntity, selectedOperation]);

  useEffect(() => {
    let initialDatabase = null;

    if (selectedEntity && selectedOperation) {
      let key = GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT;

      if (selectedOperation === OPERATIONS.LEGACY) {
        key = GLOBAL_COMPONENT_SELECT_DATABASE_LEGACY_DEFAULT
      }
      if (selectedOperation === OPERATIONS.VALIDATION) {
        key = GLOBAL_COMPONENT_SELECT_DATABASE_VALIDATION_DEFAULT
      }
      if (selectedOperation === OPERATIONS.LOADFILE) {
        key = GLOBAL_COMPONENT_SELECT_DATABASE_LOADFILE_DEFAULT
      }

      const entityDefaultDatabase = preferences.find(
        (p) =>
          p.key === key &&
          p.object === "Entity" &&
          p.objectId === selectedEntity
      );

      if (entityDefaultDatabase) {
        initialDatabase = entityDefaultDatabase.value;
      }

      if (initialDatabase == null) {
        const appDefaultDatabase = preferences.find(
          (p) =>
            p.key === key &&
            p.object === "Application"
        );

        if (appDefaultDatabase) {
          initialDatabase = appDefaultDatabase.value;
        }
      }
    }

    setDefaultDatabase(initialDatabase);
  }, [selectedEntity, selectedOperation]);

  useEffect(() => {
    if (selectedGroupCode && tables) {
      if (tables
        .filter((x: any) =>
          selectedOperation === OPERATIONS.IMPORT && selectedGroupCode
            ? x.groupCode === selectedGroupCode
            : x.groupCode === x.groupCode
        ).length === 1) {
        if (!selectedTable) {
          setSelectedTable(tables
            .filter((x: any) =>
              selectedOperation === OPERATIONS.IMPORT && selectedGroupCode
                ? x.groupCode === selectedGroupCode
                : x.groupCode === x.groupCode
            )[0])
        }
      } else {
        setSelectedTable(undefined);
      }
    }
  }, [selectedGroupCode])

  useEffect(() => {
    if (selectedTable && selectedTable?.id !== "New table") {
      setIsFieldsLoading(true);
      const model: GetFieldsRequest = {
        tableId: selectedTable?.id,
      };
      TablesService.getFields(model).then((response: any) => {
        const data = response.data;
        setFields(
          data.map((x: any) => ({
            ...x,
            icon: getIcon(x.typeId),
            isKey: x.isKey,
          }))
        );
        setIsFieldsLoading(false);
      });
    }
  }, [selectedTable?.id]);

  useEffect(() => {
    SystemService.getAll()
      .then((res) => {
        setSystems(res.data);
      });
  }, []);

  function onlyUnique(value: any, index: any, self: any) {
    return self.indexOf(value) === index;
  }

  const onTabChange = (key: string) => {
    if (selectedTable && updateTableAllowed) {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        setSelectedTable(undefined);
        setSelectedField(undefined);
        checkPreferences();
        setCurrentActiveKey(key);
      }
    } else if (selectedField && updateFieldAllowed) {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        setSelectedTable(undefined);
        setSelectedField(undefined);
        checkPreferences();
        setCurrentActiveKey(key);
      }
    } else {
      searchParams.set("tab", key);
      setSearchParams(searchParams);
      setCurrentActiveKey(key);
    }
  };

  const checkPreferences = () => {
    ApplicationService.getPreferences().then((response: any) => {
      const data = response.data;
      setPreferences(data);
      UsersService.userGroups(profile.id).then((response) => {
        const userGroups: number[] = response.data;
        let advancedOptionsPreference: any = preferences.find(
          (p) =>
            p.key === TABLE_SETUP_COMPONENT_ADVANCED_OPTIONS_TOGGLE &&
            p.object === "User" &&
            p.objectId === profile.id
        );

        if (!advancedOptionsPreference) {
          advancedOptionsPreference = preferences
            .filter(
              (p) =>
                p.key === TABLE_SETUP_COMPONENT_ADVANCED_OPTIONS_TOGGLE &&
                p.object === "UserGroup" &&
                userGroups.includes(p.objectId)
            )
            .sort()
            .reverse()[0];

          // if (advancedOptionsPreference.length > 1) {
          //   advancedOptionsPreference.sort()
          // }
        }

        if (!advancedOptionsPreference) {
          advancedOptionsPreference = preferences.find(
            (p) =>
              p.key === TABLE_SETUP_COMPONENT_ADVANCED_OPTIONS_TOGGLE &&
              p.object === "Application"
          );
        }

        setAdditionalOptionsVisible(
          advancedOptionsPreference?.value.toLowerCase() === "true"
        );
      });

      // const advancedOptionsPreferences = preferences.filter(p =>
      //   p.key === TABLE_SETUP_COMPONENT_ADVANCED_OPTIONS_TOGGLE &&
      //   (
      //     p.object === "Application" ||
      //     (p.object === "User" && p.objectId === profile.id) ||
      //     (p.object === "UserGroup" && userGroups.includes(p.objectId))
      //   )
      // );
      // const validPreference = advancedOptionsPreferences.

      // setAdditionalOptionsVisible(preferences.find((x:any) => x.key === TABLE_SETUP_COMPONENT_ADVANCED_OPTIONS_TOGGLE)?.value.toLowerCase() === "true");
    });
  };

  const handleTableChange = (value: string) => {
    setSelectedTable(tables.find((x: any) => x.id === value));
    setFields([]);
    setSelectedField(undefined);
    checkPreferences();
  };
  const handleTableMenuClick = (e: any) => {
    if (selectedTable && selectedTable.id.toString() === e.key) {
      return;
    }
    setSelectedTable(tables.find((x: any) => x.id.toString() === e.key));
    setFields([]);
    setSelectedField(undefined);
    checkPreferences();
  };

  const handleFieldChange = (value: string) => {
    setFormatOptions([]);
    setDependentColumns([]);
    setDependentType(undefined);
    
    const selectedField = fields.find((x: any) => x.id === value);
    setSelectedField(selectedField);
    if (selectedOperation === OPERATIONS.VALIDATION) {
      TablesService.getValidationField(selectedField.id).then(
        (response: any) => {
          const extendedField = {
            ...selectedField,
            datatypeOverride: response.data.datatype,
            maxLengthOverride: response.data.maxLength,
            precisionOverride: response.data.precision,
            scaleOverride: response.data.scale,
          };
          setSelectedField(extendedField);
          setSelectedValidationField(response.data);
        }
      );
    } else {
      setSelectedField(selectedField);
    }
    checkPreferences();
  };

  const handleFieldMenuClick = (value: any) => {
    setFormatOptions([]);
    setDependentColumns([]);
    setDependentType(undefined);
    
    const selectedField = fields.find(
      (x: any) => x.id.toString() === value.toString()
    );
    setSelectedField(selectedField);
    if (selectedOperation === OPERATIONS.VALIDATION) {
      TablesService.getValidationField(selectedField.id).then(
        (response: any) => {
          const extendedField = {
            ...selectedField,
            datatypeOverride: response.data.datatype,
            maxLengthOverride: response.data.maxLength,
            precisionOverride: response.data.precision,
            scaleOverride: response.data.scale,
          };
          setSelectedField(extendedField);
          setSelectedValidationField(response.data);
        }
      );
    } else {
      setSelectedField(selectedField);
    }

    checkPreferences();
  };

  const onAddTableClick = (e: any) => {
    const entity = entities.find((x: any) => x.id === selectedEntity);
    setSelectedTable({
      id: "New table",
      name: "",
      schema: entity?.name,
      database:
        defaultDatabase
          ? defaultDatabase
          : databases.length === 1
            ? databases[0].name
            : null,
    });

    if (selectedOperation === OPERATIONS.IMPORT) {
      if (!entity?.defaultImportDatabase || entity?.defaultImportDatabase.length === 0) {
        setTriggerDatabaseRef(true);
      }
    }
    if (selectedOperation === OPERATIONS.LEGACY) {
      if (!entity?.defaultLegacyDatabase || entity?.defaultLegacyDatabase.length === 0) {
        setTriggerDatabaseRef(true);
      }
    }
    if (selectedOperation === OPERATIONS.VALIDATION) {
      if (!entity?.defaultValidationDatabase || entity?.defaultValidationDatabase.length === 0) {
        setTriggerDatabaseRef(true);
      }
    }
    if (selectedOperation === OPERATIONS.LOADFILE) {
      if (!entity?.defaultLoadFileDatabase || entity?.defaultLoadFileDatabase.length === 0) {
        setTriggerDatabaseRef(true);
      }
    }
  };
  const onAddFieldClick = (e: any) => {
    setFormatOptions([]);
    setDependentColumns([]);
    setDependentType(undefined);
    
    setSelectedField({ id: "New field", name: "", deltaCollection: "ALL" });
    checkPreferences();
  };

  const onSelectedTableDatabaseChange = (value: string) => {
    setSelectedTable({ ...selectedTable, database: value });
  };

  const onSelectedTableSchemaChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedTable({ ...selectedTable, schema: event.target.value });
  };

  const onSelectedTableNameChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedTable({
      ...selectedTable,
      name: event.target.value,
    });
  };

  const onSelectedTableGroupCodeChange = (value: string) => {
    setSelectedTable({ ...selectedTable, groupCode: value });
  };

  const onSelectedTableSystemChange = (value: number) => {
    setSelectedTable({ ...selectedTable, systemId: value });
  }

  const onSelectedTableDescriptionChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setSelectedTable({ ...selectedTable, description: event.target.value });
  };

  const onSelectedTableonlyValidateFieldsInCurrentLoadfile = (event: CheckboxChangeEvent) => {
    setSelectedTable({
      ...selectedTable,
      onlyValidateFieldsInCurrentLoadfile: event.target.checked,
    });
  };

  //onSelectedTableImportFreeze
  const onSelectedTableImportFreeze = (event: CheckboxChangeEvent) => {
    setSelectedTable({
      ...selectedTable,
      importFreeze: event.target.checked,
    });
  };


  const onSelectedFieldNameChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedField({
      ...selectedField,
      name: event.target.value,
    });
  };

  const onSelectedFieldDatatypeChange = (value: string) => {
    setSelectedField({
      ...selectedField,
      datatype: value,
      maxLength:
        !selectedField?.maxLength &&
          (value.toLowerCase() === "nvarchar" || value.toLowerCase() === "varchar")
          ? 500
          : selectedField?.maxLength,
    });
  };

  const onSelectedFieldDatatypeOverrideChange = (value: string) => {
    setSelectedField({ ...selectedField, datatypeOverride: value });
  };

  const onSelectedFieldMaxLengthChange = (value: number) => {
    setSelectedField({ ...selectedField, maxLength: value });
  };

  const onSelectedFieldPrecisionChange = (value: number) => {
    if (value > 32) {
      return;
    }

    setSelectedField({ ...selectedField, precision: value });
  };

  const onSelectedFieldScaleChange = (value: number) => {
    if (value > 12) {
      return;
    }

    setSelectedField({ ...selectedField, scale: value });
  };

  const onSelectedFieldDeltaCollectionChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedField({ ...selectedField, deltaCollection: event.target.value });
  };

  const onSelectedFieldDeltaCollectionBlur: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    if (!selectedField.deltaCollection) {
      setSelectedField({ ...selectedField, deltaCollection: "ALL" });
    }
  };

  const onSelectedFieldOwnerChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedField({ ...selectedField, owner: event.target.value });
  };

  const onSelectedFieldWhoToSolveChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedField({ ...selectedField, whoToSolve: event.target.value });
  };

  const onSelectedFieldLabelChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedField({ ...selectedField, label: event.target.value });
  };

  const onFieldMaxLengthOverrideChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setSelectedField({
      ...selectedField,
      maxLengthOverride: event.target.value,
    });
  };

  const handleScanTable = () => {
    if (selectedTable?.id && selectedEntity) {
      const entityName = entities.find((x: any) => x.id === selectedEntity)?.name;
      TablesService.scanTable(selectedTable.id, entityName)
        .then(() => {
          NotificationsUtil.openNotificationDialog({
            description: t("Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Table.ScanSuccess", {
              lngs: i18n.languages,
              defaultValue: "Table has been successfully scanned.",
            })!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });

          const model: GetFieldsRequest = {
            tableId: selectedTable.id,
          };
          TablesService.getFields(model).then((response: any) => {
            const data = response.data;
            setFields(
              data.map((x: any) => ({
                ...x,
                icon: getIcon(x.typeId),
                isKey: x.isKey,
              }))
            );
            resetField();
          });
        })
        .catch((error) => {
          console.error("Error scanning table:", error);
          NotificationsUtil.openNotificationDialog({
            description: t("Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Table.ScanError", {
              lngs: i18n.languages,
              defaultValue: "Failed to scan table.",
            })!,
            type: NOTIFICATION_TYPES.ERROR,
            logError: false,
          });
        });
    }
  };

  const onFieldPrecisionChange = (value: number) => {
    if (value > 32) {
      return;
    }

    setSelectedField({
      ...selectedField,
      precisionOverride: value,
    });
  };

  const onFieldScaleChange = (value: number) => {
    if (value > 12) {
      return;
    }

    setSelectedField({
      ...selectedField,
      scaleOverride: value,
    });
  };

  const onSelectedFieldDescriptionChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setSelectedField({ ...selectedField, description: event.target.value });
  };

  const onSelectedFieldCustomQueryChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setSelectedField({ ...selectedField, referenceListValue: event.target.value });
  };


  const onSelectedFieldIsMandatoryChange = (event: CheckboxChangeEvent) => {
    setSelectedField({
      ...selectedField,
      isMandatory: event.target.checked,
    });
  };

  const onSelectedFieldIsKeyChange = (e: CheckboxChangeEvent) => {
    setSelectedField({ ...selectedField, isKey: e.target.checked });
    setUpdateFieldAllowed(true);
  };

  const onSelectedFieldIsTruncateChange = (event: CheckboxChangeEvent) => {
    setSelectedField({
      ...selectedField,
      isTruncate: event.target.checked,
    });
  };

  const onSelectedFieldFieldLabelChange = (value: number) => {
    setSelectedField({
      ...selectedField,
      typeId: value,
      subtypeFormatId: undefined,
      subtypeCountryFieldId: undefined,
      datatype: fieldTypes.find(x => x.id == value)?.name.includes("ReferenceList") ? "nvarchar(max)" : selectedField.datatype
    });
  };

  const onSelectedFieldReferenceListTypeChange = (value: number) => {
    setSelectedField({ ...selectedField, referenceListType: value, referenceListValue: undefined });
  };

  const onSelectedFieldReferenceListValueChange = (value: number) => {
    setSelectedField({ ...selectedField, referenceListValue: value });
  };

  const onSelectedFieldReferenceListValueCanUserAddChange = (event: CheckboxChangeEvent) => {
    setSelectedField({
      ...selectedField,
      referenceListValueCanUserAdd: event.target.checked,
    });
  };

  const handleNewTranslationButtonClick = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    setNewTranslationDrawerEnabled(true);
  };

  const handleNewReferenceButtonClick = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    setNewReferenceDrawerEnabled(true);
  };

  const handleViewClick = () => {
    showViewData();
    setShowViewDrawer(true);
  };

  const handleRecreateTableClick = () => {
    // setShowOptionsModal(true);
    setShowEditFieldsDrawer(true);
    setSourceKeys(fields.filter((x: any) => x.isKey).map(x => x.name));
    setRecreateTableDataSource(
      fields.map((x: any) => {
        return {
          ...x,
          mandatory: x.isMandatory,
          fieldName: x.name,
          autotrim: x.isTruncate,
          datatype: x.datatype.toLowerCase(),
          owner: x.owner,
          whoToSolve: x.whoToSolve,

        };
      })
    );
  };

  const handleRecreateTableOk = () => {
    if (recreateSelectedSource === "blankTable") {
      setShowOptionsModal(false);
      setRecreateSelectedSourceEntity(undefined);
      setRecreateSelectedSourceOperation(undefined);
      setRecreateSelectedSourceTable(undefined);
      setRecreateSelectedSourceTables([]);
      setRecreateSelectedUploadFile(null);
    }
    if (recreateSelectedSource === "existingTable") {
      if (!recreateSelectedSourceTable) {
        return;
      }
      const model: any = {
        fromTableId: recreateSelectedSourceTable,
      };

      TablesService.importRecreateTableFromTable(model)
        .then((response: any) => {
          let newDataSource: any = recreateTableFields;
          if (
            newDataSource[newDataSource.length - 1] &&
            newDataSource[newDataSource.length - 1].fieldName === ""
          ) {
            newDataSource.pop();
          }

          const data = response.data;

          for (let i = 0; i < data.length; i++) {
            if (
              (selectedOperation === OPERATIONS.LEGACY ||
                recreateSelectedSourceOperation === OPERATIONS.LEGACY) &&
              [
                "code",
                "groupcode",
                "run_date",
                "deltastatus",
                "mod_dt_all",
                "sourcedata",
              ].indexOf(data[i].fieldName.toLowerCase()) > -1
            ) {
              continue; // ignore technical fields
            }
            if (
              (selectedOperation === OPERATIONS.VALIDATION ||
                recreateSelectedSourceOperation === OPERATIONS.VALIDATION) &&
              ["code", "groupcode", "environment"].indexOf(
                data[i].fieldName.toLowerCase()
              ) > -1
            ) {
              continue; // ignore technical fields
            }
            if (
              (selectedOperation === OPERATIONS.LOADFILE ||
                recreateSelectedSourceOperation === OPERATIONS.LOADFILE) &&
              ["code", "groupcode", "system", "environment"].indexOf(
                data[i].fieldName.toLowerCase()
              ) > -1
            ) {
              continue; // ignore technical fields
            }

            let existingObjectIndex = newDataSource.findIndex((x: any) =>
              x.fieldName
                ? x.fieldName.toLowerCase() ===
                response.data[i].fieldName.toLowerCase()
                : x.name?.toLowerCase() ===
                response.data[i].fieldName.toLowerCase()
            );
            if (existingObjectIndex > -1) {
              newDataSource[existingObjectIndex] = response.data[i]; // update existing
            } else {
              let newRecord = response.data[i];
              if (
                newDataSource.findIndex(
                  (x: any) => x.position === newRecord.position
                ) > -1
              ) {
                newRecord.position =
                  Math.max(...newDataSource.map((o: any) => o.position)) + 1;
              }
              newDataSource.push(newRecord); // create new
            }
          }

          setRecreateTableFields([...newDataSource]);
          setShowOptionsModal(false);
          setRecreateSelectedSourceEntity(undefined);
          setRecreateSelectedSourceOperation(undefined);
          setRecreateSelectedSourceTable(undefined);
          setRecreateSelectedSourceTables([]);
          setRecreateSelectedUploadFile(null);
        })
        .catch((error: any) => {
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        });
    }
    if (recreateSelectedSource === "excelFile") {
      if (!recreateSelectedUploadFile) {
        return;
      }

      const model: any = {
        file: recreateSelectedUploadFile,
        tableId: selectedTable?.id,
      };

      TablesService.importRecreateTableFromExcel(model)
        .then((response: any) => {
          let newDataSource: any = recreateTableDataSource;
          if (
            newDataSource[newDataSource.length - 1] &&
            newDataSource[newDataSource.length - 1].fieldName === ""
          ) {
            newDataSource.pop();
          }
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].datatype = response.data[i].datatype.toLowerCase();
            if (response.data[i].fieldName.length <= 0) {
              continue; // skip empty field
            }
            if (
              selectedOperation === OPERATIONS.LEGACY &&
              [
                "code",
                "groupcode",
                "run_date",
                "deltastatus",
                "mod_dt_all",
                "sourcedata",
              ].indexOf(response.data[i].fieldName.toLowerCase()) > -1
            ) {
              continue; // ignore technical fields
            }
            if (
              selectedOperation === OPERATIONS.VALIDATION &&
              ["code", "groupcode", "environment"].indexOf(
                response.data[i].fieldName.toLowerCase()
              ) > -1
            ) {
              continue; // ignore technical fields
            }
            if (
              selectedOperation === OPERATIONS.LOADFILE &&
              ["code", "groupcode", "system", "environment"].indexOf(
                response.data[i].fieldName.toLowerCase()
              ) > -1
            ) {
              continue; // ignore technical fields
            }

            let existingObjectIndex = newDataSource.findIndex(
              (x: any) =>
                x.fieldName.toLowerCase() ===
                response.data[i].fieldName.toLowerCase()
            );
            if (existingObjectIndex > -1) {
              newDataSource[existingObjectIndex] = response.data[i]; // update existing
            } else {
              let newRecord = response.data[i];
              if (
                newDataSource.findIndex(
                  (x: any) => x.position === newRecord.position
                )
              ) {
                newRecord.position =
                  Math.max(...newDataSource.map((o: any) => o.position)) + 1;
              }
              newDataSource.push(newRecord); // create new
            }
          }

          setRecreateTableDataSource([...newDataSource]);
          setShowOptionsModal(false);
          setRecreateSelectedSourceEntity(undefined);
          setRecreateSelectedSourceOperation(undefined);
          setRecreateSelectedSourceTable(undefined);
          setRecreateSelectedSourceTables([]);
          setRecreateSelectedUploadFile(null);
        })
        .catch((error: any) => {
          let errorResponse = '';

          if (error?.response?.data?.Message) {
            errorResponse = error.response.data.Message;
          } else if (error?.response?.data) {
            errorResponse = error?.response?.data;
          } else if (error?.response?.Message) {
            errorResponse = error.response.Message;
          } else if (error?.message) {
            errorResponse = error.message;
          } else {
            errorResponse = "Unexpected error: " + error + ". Please contact administrators.";
          }

          NotificationsUtil.openNotificationDialog({
            description: errorResponse,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        });
    }
  };

  const initRecreateTableDataSource = () => {
    setRecreateTableDataSource([
      {
        key: 9,
        fieldName: "",
        datatype: "",
        maxLength: 0,
        autotrim: false,
        precision: 0,
        scale: 0,
        label: "",
        description: "",
        owner: "",
        whoToSolve: "",
        deltaCollection: "ALL",
        mandatory: false,
        position: 1,
        nonEditable: false,
      },
    ]);
  };

  const handleUploadFileChange = (value: UploadChangeParam<UploadFile>) => {
    if (value.fileList.length === 0) {
      setRecreateSelectedUploadFile(null);
    } else {
      setRecreateSelectedUploadFile(value?.fileList[0].originFileObj);
      // const file: any = value?.fileList[0].originFileObj;
      // TranslationService.uploadTranslations(file);
    }
  };

  const preventRequest = () => false;
  const customRequest = (options: any) => {
    // options?.onSuccess?("ok")
  };

  const handleRecreateTableClose = () => {
    onCloseRecreateTable();
    setIsEditFieldsDirty(false);
  };

  const handleViewExportClick = () => {
    setShowViewExportDrawer(true);
  };

  const onCloseRecreateTable = () => {
    setShowEditFieldsDrawer(false);
    setShowOptionsModal(false);
    setSourceKeys([]);
    setIsCheckboxChanged(false);
    setRecreateSelectedSourceEntity(undefined);
    setRecreateSelectedSourceOperation(undefined);
    setRecreateSelectedSourceTable(undefined);
    setRecreateSelectedSourceTables([]);
    setRecreateSelectedUploadFile(null);
    setRecreateSelectedSource("blankTable");
    initRecreateTableDataSource();
    setNewTableEdit(false);

    const model: GetTablesRequest = {
      entityId: selectedEntity,
      operationId: selectedOperation,
      groupCode: "",
    };

    TablesService.getTables(model).then((response: any) => {
      const data = response.data;
      setTables(data);
    });

    const fieldsModel: GetFieldsRequest = {
      tableId: selectedTable?.id,
    };

    TablesService.getFields(fieldsModel).then((fieldsResponse: any) => {
      const fieldsData = fieldsResponse.data;
      setFields(
        fieldsData.map((x: any) => ({
          ...x,
          icon: getIcon(x.typeId),
          isKey: x.isKey,
        }))
      );

      if (selectedField) {
        setSelectedField(fieldsData.find(x => x.id === selectedField.id));
      }
    });
  };

  const onCloseView = () => {
    setShowViewDrawer(false);
    setSelectedViewDataGroupCode("");
    setSelectedViewDataRowsToShow(100);
    setSelectedExportViewDataRowsToShow(100);
    setSelectedExportViewDataGroupCode("");
  };

  const onCloseViewExport = () => {
    setShowViewExportDrawer(false);
  };

  const onSelectedViewDataRowsToShowChange = (value: any) => {
    setSelectedViewDataRowsToShow(value);
    setSelectedExportViewDataRowsToShow(value);
    drawerForm.setFieldsValue({ viewDataNumberOfRows: value });
    exportForm.setFieldsValue({ exportNumberOfRows: value });
  };

  const onSelectedExportViewDataRowsToShowChange = (value: any) => {
    setSelectedExportViewDataRowsToShow(value);
    exportForm.setFieldsValue({ exportNumberOfRows: value });
  };

  const onRecreateTableNameChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    if (/^[A-Za-z0-9_]*$/.test(event.target.value)) {
      setRecreateTableName(event.target.value.replace(/\s/g, ""));
    }
  };

  const onRecreateTableDatabaseChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setRecreateTableDatabase(event.target.value);
    drawerForm.setFieldsValue({ recreateTableDatabase: event.target.value });
  };

  const onRecreateTableSchemaChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    setRecreateTableSchema(event.target.value);
    drawerForm.setFieldsValue({ recreateTableSchema: event.target.value });
  };

  useEffect(() => {
    if (!userHasPermissions.write) {
      setUpdateTableAllowed(false);
      return;
    }

    if (selectedTable && tables) {
      const current = JSON.stringify(selectedTable);
      const def = JSON.stringify(
        tables.find((x: any) => x.id === selectedTable.id)
      );

      if (!selectedTable?.name || selectedTable?.name?.length === 0) {
        setUpdateTableAllowed(false);
        return;
      }

      if (!selectedTable?.database || selectedTable?.database?.length === 0) {
        setUpdateTableAllowed(false);
        return;
      }

      if (!selectedTable?.schema || selectedTable?.schema?.length === 0) {
        setUpdateTableAllowed(false);
        return;
      }

      if (
        selectedOperation === OPERATIONS.IMPORT &&
        !selectedGroupCode &&
        !selectedTable?.groupCode
      ) {
        setUpdateTableAllowed(false);
        return;
      }

      if (!def) {
        setUpdateTableAllowed(true);
        return;
      }

      if (current !== def) {
        setUpdateTableAllowed(true);
      } else {
        setUpdateTableAllowed(false);
      }
    } else {
      setUpdateTableAllowed(false);
    }
  }, [selectedTable, tables]);

  useEffect(() => {
    if (!userHasPermissions.write) {
      setUpdateFieldAllowed(false);
      return;
    }
    if (selectedField && fields) {
      const current = JSON.stringify(selectedField);
      let field = fields.find((x: any) => x.id === selectedField.id);

      if (field && selectedValidationField) {
        field.datatypeOverride = selectedValidationField.datatype;
        field.maxLengthOverride = selectedValidationField.maxLength;
        field.precisionOverride = selectedValidationField.precision;
        field.scaleOverride = selectedValidationField.scale;
      }

      let def = JSON.stringify(field);

      if (!selectedField?.name || selectedField?.name?.length === 0) {
        setUpdateFieldAllowed(false);
        return;
      }

      if (!selectedField?.datatype || selectedField?.datatype?.length === 0) {
        setUpdateFieldAllowed(false);
        return;
      }

      if (!def) {
        setUpdateFieldAllowed(true);
        return;
      }

      if (current !== def) {
        setUpdateFieldAllowed(true);
      } else {
        setUpdateFieldAllowed(false);
      }
    } else {
      setUpdateFieldAllowed(false);
    }
  }, [selectedField, fields, selectedValidationField]);

  useEffect(() => {
    if (selectedTable && triggerDatabaseRef) {
      if (databaseRef?.current) {
        databaseRef.current.focus();
        setTriggerDatabaseRef(false);
      }
    }
  }, [selectedTable, triggerDatabaseRef]);

  const createTable = () => {
    if (
      selectedOperation === OPERATIONS.IMPORT &&
      !selectedGroupCode &&
      !selectedTable.groupCode
    ) {
      NotificationsUtil.openNotificationDialog({
        description: `Group code is mandatory for Import operation. Please select Group code.`,
        type: NOTIFICATION_TYPES.ERROR,
        logError: false,
      });
      return;
    }

    setCreateTableLoading(true);
    const model: CreateTableRequest = {
      entityId: selectedEntity,
      operationId: selectedOperation,
      groupCode:
        selectedOperation === OPERATIONS.IMPORT && selectedGroupCode
          ? selectedGroupCode
          : selectedTable.groupCode,
      database: selectedTable.database,
      schema: selectedTable.schema,
      name: selectedTable.name,
      description: selectedTable.description,
      onlyValidateFieldsInCurrentLoadfile: selectedOperation === OPERATIONS.LOADFILE ? selectedTable.onlyValidateFieldsInCurrentLoadfile : null,
      importFreeze: selectedOperation === OPERATIONS.IMPORT ? selectedTable.importFreeze : null,
      systemId: selectedTable.systemId,
    };

    const existingTable = tables.find(
      (x: any) =>
        x.entityId == model.entityId &&
        x.operationId == model.operationId &&
        x.groupCode == model.groupCode &&
        x.name.toLowerCase() === model.name.toLowerCase()
    );
    if (existingTable && existingTable.id != -1) {
      NotificationsUtil.openNotificationDialog({
        description: `Table with a same name '${model.name}' already exists. Please use a different name.`,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setCreateTableLoading(false);
      return;
    }

    TablesService.createTable(model)
      .then((response: any) => {
        const model: GetTablesRequest = {
          entityId: selectedEntity,
          operationId: selectedOperation,
          groupCode: "",
        };
        const tableId = response.data;

        TablesService.getTables(model).then((tablesResponse: any) => {
          const data = tablesResponse.data;
          setTables(data);
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Table.CreateSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Table has been successfully created.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });

          const newTable = data.find((x: any) => x.id === tableId);
          setSelectedTable({ ...newTable });
          setTriggerEditFieldsDrawer(true);
          setCreateTableLoading(false);
          setNewTableEdit(true);
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
        setCreateTableLoading(false);
      });
  };

  useEffect(() => {
    if (
      selectedTable &&
      selectedTable.id !== "New table" &&
      triggerEditFieldsDrawer
    ) {
      const fieldsModel: GetFieldsRequest = {
        tableId: selectedTable?.id,
      };
      TablesService.getFields(fieldsModel).then((fieldsResponse: any) => {
        const fieldsData = fieldsResponse.data;
        setFields(
          fieldsData.map((x: any) => ({
            ...x,
            icon: getIcon(x.typeId),
            isKey: x.isKey,
          }))
        );
        setSourceKeys(fieldsData.filter((x: any) => x.isKey).map(x => x.name));
        if (selectedTable.tableType == 'BASE TABLE') {
          setShowOptionsModal(true);
        }
        else {
          setShowOptionsModal(false);
        }

        setShowEditFieldsDrawer(true);
        setRecreateTableDataSource(
          fieldsData.map((x: any) => {
            return {
              ...x,
              mandatory: x.isMandatory,
              fieldName: x.name,
              autotrim: x.isTruncate,
              owner: x.owner,
              whoToSolve: x.whoToSolve,
            };
          })
        );
      });

      setTriggerEditFieldsDrawer(false);
      resetTable();
    }
  }, [selectedTable, triggerEditFieldsDrawer]);

  const updateTable = () => {
    setUpdateTableLoading(true);
    const model: UpdateTableRequest = {
      id: selectedTable.id,
      entityId: selectedTable.entityId,
      operationId: selectedTable.operationId,
      groupCode: selectedTable.groupCode,
      database: selectedTable.database,
      schema: selectedTable.schema,
      name: selectedTable.name,
      description: selectedTable.description,
      onlyValidateFieldsInCurrentLoadfile: selectedOperation === OPERATIONS.LOADFILE ? selectedTable.onlyValidateFieldsInCurrentLoadfile : null,
      importFreeze: selectedOperation === OPERATIONS.IMPORT ? selectedTable.importFreeze : null,
      systemId: selectedTable.systemId
    };

    const existingTable = tables.find(
      (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
    );
    if (
      existingTable &&
      existingTable.id != -1 &&
      existingTable.id !== selectedTable.id
    ) {
      NotificationsUtil.openNotificationDialog({
        description: `Table with a same name '${model.name}' already exists. Please use a different name.`,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setUpdateTableLoading(false);
      return;
    }

    TablesService.updateTable(model)
      .then((response: any) => {
        const model: GetTablesRequest = {
          entityId: selectedEntity,
          operationId: selectedOperation,
          groupCode: "",
        };
        TablesService.getTables(model).then((response: any) => {
          const data = response.data;
          setTables(data);
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Table.UpdateSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Table has been successfully updated.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          if (selectedGroupCode && model.groupCode !== selectedGroupCode) {
            checkPreferences();
          }
          setUpdateTableLoading(false);
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
        setUpdateTableLoading(false);
      });
  };

  const deleteTable = () => {
    const model: DeleteTableRequest = {
      id: selectedTable?.id,
    };
    TablesService.deleteTable(model)
      .then((response: any) => {
        const model: GetTablesRequest = {
          entityId: selectedEntity,
          operationId: selectedOperation,
          groupCode: "",
        };
        TablesService.getTables(model).then((response: any) => {
          const data = response.data;
          setTables(data);
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Table.DeleteSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Table has been successfully deleted.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          setSelectedTable(undefined);
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      });
  };

  const createField = () => {
    setUpdateFieldLoading(true);
    const model: CreateFieldRequest = {
      tableId: selectedTable.id,
      name: selectedField.name,
      description: selectedField.description,
      datatype: selectedField.datatype,
      datatypeOverride: selectedField.datatypeOverride,
      maxLengthOverride: selectedField.maxLengthOverride,
      precisionOverride: selectedField.precisionOverride,
      scaleOverride: selectedField.scaleOverride,
      precision: selectedField.precision,
      scale: selectedField.scale,
      maxLength: selectedField.maxLength,
      isMandatory: selectedField.isMandatory,
      deltaCollection: selectedField.deltaCollection,
      owner: selectedField.owner,
      whoToSolve: selectedField.whoToSolve,
      label: selectedField.label,
      isTruncate: selectedField.isTruncate,
      typeId: selectedField.typeId,
      subtypeCountryFieldId: selectedField.subtypeCountryFieldId,
      subtypeFormatId: selectedField.subtypeFormatId,
      referenceListType: fieldTypes.find(x => x.id == selectedField.typeId)?.name.includes("Reference") ? selectedField.referenceListType : null,
      referenceListValue: fieldTypes.find(x => x.id == selectedField.typeId)?.name.includes("Reference") ? selectedField.referenceListValue : null,
      referenceListValueCanUserAdd: fieldTypes.find(x => x.id == selectedField.typeId)?.name.includes("Reference") ? selectedField.referenceListValueCanUserAdd : null
    };

    if (selectedField?.typeId && !selectedField.subtypeFormatId && formatOptions.length > 0) {
      NotificationsUtil.openNotificationDialog({
        description: "Field format is required.",
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setUpdateFieldLoading(false);
      return;
    }
    if (!selectedField.subtypeCountryFieldId && dependentType) {
      NotificationsUtil.openNotificationDialog({
        description: `${dependentType?.name} is required`,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setUpdateFieldLoading(false);
      return;
    }

    const existingField = fields.find(
      (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
    );
    if (existingField && existingField.id != -1) {
      NotificationsUtil.openNotificationDialog({
        description: `Field with a same name '${model.name}' already exists. Please use a different name.`,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setUpdateFieldLoading(false);
      return;
    }

    TablesService.createField(model)
      .then((response: any) => {
        const model: GetFieldsRequest = {
          tableId: selectedTable.id,
        };
        TablesService.getFields(model).then((response: any) => {
          const data = response.data;
          setFields(
            data.map((x: any) => ({
              ...x,
              icon: getIcon(x.typeId),
              isKey: x.isKey,
            }))
          );
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Field.CreateSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Field has been successfully created.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          setUpdateFieldLoading(false);
          resetField();
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
        setUpdateFieldLoading(false);
      });
  };

  const updateField = () => {
    setUpdateFieldLoading(true);

    const model: UpdateFieldRequest = {
      id: selectedField.id,
      tableId: selectedField.tableId,
      name: selectedField.name,
      description: selectedField.description,
      datatype: selectedField.datatype,
      datatypeOverride: selectedField.datatypeOverride,
      maxLengthOverride: selectedField.maxLengthOverride,
      precisionOverride: selectedField.precisionOverride,
      scaleOverride: selectedField.scaleOverride,
      precision: selectedField.precision,
      scale: selectedField.scale,
      maxLength: selectedField.maxLength,
      isMandatory: selectedField.isMandatory,
      isKey: selectedField.isKey,
      deltaCollection: selectedField.deltaCollection,
      label: selectedField.label,
      owner: selectedField.owner,
      whoToSolve: selectedField.whoToSolve,
      isTruncate: selectedField.isTruncate,
      typeId: selectedField.typeId,
      subtypeCountryFieldId: selectedField.subtypeCountryFieldId,
      subtypeFormatId: selectedField.subtypeFormatId,
      referenceListType: fieldTypes.find(x => x.id == selectedField.typeId)?.name.includes("Reference") ? selectedField.referenceListType : null,
      referenceListValue: fieldTypes.find(x => x.id == selectedField.typeId)?.name.includes("Reference") ? selectedField.referenceListValue : null,
      referenceListValueCanUserAdd: fieldTypes.find(x => x.id == selectedField.typeId)?.name.includes("Reference") ? selectedField.referenceListValueCanUserAdd : null
    };

    if (selectedField?.typeId && !selectedField.subtypeFormatId && formatOptions.length > 0) {
      NotificationsUtil.openNotificationDialog({
        description: "Field format is required.",
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setUpdateFieldLoading(false);
      return;
    }
    if (!selectedField.subtypeCountryFieldId && dependentType) {
      NotificationsUtil.openNotificationDialog({
        description: `${dependentType?.name} is required`,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setUpdateFieldLoading(false);
      return;
    }

    const existingField = fields.find(
      (x: any) => x.name.toLowerCase() === model.name.toLowerCase()
    );
    if (
      existingField &&
      existingField.id != -1 &&
      existingField.id !== selectedField.id
    ) {
      NotificationsUtil.openNotificationDialog({
        description: `Field with a same name '${model.name}' already exists. Please use a different name.`,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setUpdateFieldLoading(false);
      return;
    }

    TablesService.updateField(model)
      .then((response: any) => {
        const model: GetFieldsRequest = {
          tableId: selectedTable.id,
        };
        TablesService.getFields(model).then((response: any) => {
          const data = response.data;
          setFields(
            data.map((x: any) => ({
              ...x,
              icon: getIcon(x.typeId),
              isKey: x.isKey,
            }))
          );
          TablesService.getValidationField(selectedField.id).then(
            (responseValidation: any) => {
              setSelectedValidationField(responseValidation.data);

              NotificationsUtil.openNotificationDialog({
                description: t(
                  "Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Field.UpdateSuccessDescription",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Field has been successfully updated.",
                  }
                )!,
                type: NOTIFICATION_TYPES.SUCCESS,
                logError: false,
              });
              setUpdateFieldLoading(false);
            }
          );
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
        setUpdateFieldLoading(false);
      });
  };

  const deleteField = () => {
    const model: DeleteFieldRequest = {
      id: selectedField?.id,
    };
    TablesService.deleteField(model)
      .then((response: any) => {
        const model: GetFieldsRequest = {
          tableId: selectedTable.id,
        };
        TablesService.getFields(model).then((response: any) => {
          const data = response.data;
          setFields(
            data.map((x: any) => ({
              ...x,
              icon: getIcon(x.typeId),
              isKey: x.isKey,
            }))
          );
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Field.DeleteSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Field has been successfully deleted.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          setSelectedField(undefined);
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: t(
            "Page.Configuration.TableSetup.Tabs.TableSetup.Notifications.Field.DeleteErrorDescription",
            {
              lngs: i18n.languages,
              defaultValue: error.response.data,
            }
          )!,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      });
  };

  const resetTable = () => {
    const defaultTable = tables.find((x: any) => x.id === selectedTable?.id);
    if (defaultTable) {
      setSelectedTable(defaultTable);
    } else {
      setSelectedTable({
        id: "New table",
        name: "",
        schema: entities.find((x: any) => x.id === selectedEntity)?.name,
        database: defaultDatabase
          ? defaultDatabase
          : databases.length === 1
            ? databases[0].name
            : null,
      });
    }
  };

  const resetField = () => {
    const defaultField = fields.find((x: any) => x.id === selectedField?.id);
    if (defaultField) {
      setSelectedField(defaultField);
    } else {
      setSelectedField({ id: "New field", name: "", deltaCollection: "ALL" });
    }
  };

  useEffect(() => {
    if (tableRef?.current) {
      if (selectedEntity && selectedOperation) {
        tableRef.current.focus();
        return;
      }
      tableRef.current.blur();
    }
  }, [selectedEntity, selectedOperation]);

  useEffect(() => {
    if (recreateSelectedSourceEntity && recreateSelectedSourceOperation) {
      const model: GetTablesRequest = {
        entityId: recreateSelectedSourceEntity,
        operationId: recreateSelectedSourceOperation,
        groupCode: "",
      };

      TablesService.getTables(model).then((response: any) => {
        setRecreateSelectedSourceTables(response.data);
      });
    }
  }, [recreateSelectedSourceEntity, recreateSelectedSourceOperation]);

  useEffect(() => {
    if (!selectedField) {
      setFormatOptions([]);
      setDependentColumns([]);
      setDependentType(undefined);
    }
  }, [selectedField]);

  interface DataType {
    key: string;
    fromValue: string;
    toValue: string;
  }

  const handleRecreateTableMenuItemClick = (menuInfo: MenuInfo) => {
    if (menuInfo.key === "1") {
      setUploadRecreateTableFromExcelDrawerEnabled(true);
    }
    if (menuInfo.key === "2") {
      setUploadRecreateTableFromTableDrawerEnabled(true);
    }
    if (menuInfo.key === "3") {
      setDownloadDownloadRecreateTableAsExcelDrawerEnabled(true);
    }
    if (menuInfo.key === "4") {
      setDownloadDownloadRecreateTableAsEmptyExcelDrawerEnabled(true);
    }
  };

  const handleTranslationsMenuItemClick = (menuInfo: MenuInfo) => {
    if (menuInfo.key === "1") {
      setDownloadTranslationDrawerEnabled(true);
    }
    if (menuInfo.key === "2") {
      setUploadTranslationDrawerEnabled(true);
    }
    if (menuInfo.key === "3") {
      setDownloadTranslationTemplateDrawerEnabled(true);
    }
  };

  const handleReferencesMenuItemClick = (menuInfo: MenuInfo) => {
    if (menuInfo.key === "1") {
      setDownloadReferenceDrawerEnabled(true);
    }
    if (menuInfo.key === "2") {
      setUploadReferenceDrawerEnabled(true);
    }
    if (menuInfo.key === "3") {
      setDownloadReferenceTemplateDrawerEnabled(true);
    }
  };

  const dropdownMenuRecreateTableActions = (
    <Menu
      className="twoFoldMenu"
      style={{ padding: "10px" }}
      selectable
      onClick={handleRecreateTableMenuItemClick}
      items={[
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.RecreateTableImportFromExcel",
            {
              lngs: i18n.languages,
              defaultValue: "Import from .xlsx template",
            }
          ),
          key: "1",
          icon: <UploadOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.RecreateTableImportFromTable",
            {
              lngs: i18n.languages,
              defaultValue: "Import from other table",
            }
          ),
          key: "2",
          icon: <UploadOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.RecreateTableDownloadAsExcel",
            {
              lngs: i18n.languages,
              defaultValue: "Download as .xlsx template",
            }
          ),
          key: "3",
          icon: <DownloadOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.RecreateTableDownloadEmptyExcel",
            {
              lngs: i18n.languages,
              defaultValue: "Download empty .xlsx template",
            }
          ),
          key: "4",
          icon: <DownloadOutlined />,
        },
      ]}
    />
  );

  const dropdownMenuTranslations = (
    <Menu
      className="twoFoldMenu"
      style={{ padding: "10px" }}
      selectable
      onClick={handleTranslationsMenuItemClick}
      items={[
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.Translations.Labels.ActionDownloadTranslations",
            {
              lngs: i18n.languages,
              defaultValue: "Download translations",
            }
          ),
          key: "1",
          icon: <DownloadOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.Translations.Labels.ActionDownloadTemplate",
            {
              lngs: i18n.languages,
              defaultValue: "Download template",
            }
          ),
          key: "3",
          icon: <DownloadOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.Translations.Labels.ActionUploadTranslations",
            {
              lngs: i18n.languages,
              defaultValue: "Upload translations",
            }
          ),
          key: "2",
          icon: <UploadOutlined />,
        },
      ]}
    />
  );

  const actionButtonTranslations = (
    <Dropdown.Button
      // disabled={!selectedEntity || !selectedGroupCode}
      type={"primary"}
      onClick={handleNewTranslationButtonClick}
      overlay={dropdownMenuTranslations}
      className="actionButton"
      placement="bottomRight"
      // arrow={DropdownArrowOptions.}
      trigger={["click"]}
      icon={<DownOutlined />}
    >
      <PlusOutlined />
      {t(
        "Page.Configuration.TableSetup.Tabs.Translations.Labels.ActionAddTranslation",
        {
          lngs: i18n.languages,
          defaultValue: "ADD TRANSLATION",
        }
      )}
    </Dropdown.Button>
  );

  const dropdownMenuReferences = (
    <Menu
      className="twoFoldMenu"
      style={{ padding: "10px" }}
      selectable
      onClick={handleReferencesMenuItemClick}
      items={[
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.References.Labels.ActionDownloadReferences",
            {
              lngs: i18n.languages,
              defaultValue: "Download references",
            }
          ),
          key: "1",
          icon: <DownloadOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.References.Labels.ActionDownloadTemplate",
            {
              lngs: i18n.languages,
              defaultValue: "Download template",
            }
          ),
          key: "3",
          icon: <DownloadOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.References.Labels.ActionUploadReferences",
            {
              lngs: i18n.languages,
              defaultValue: "Upload references",
            }
          ),
          key: "2",
          icon: <UploadOutlined />,
        },
      ]}
    />
  );

  const actionButtonReferences = (
    <Dropdown.Button
      // disabled={!selectedEntity || !selectedGroupCode}
      type={"primary"}
      onClick={handleNewReferenceButtonClick}
      overlay={dropdownMenuReferences}
      className="actionButton"
      placement="bottomRight"
      // arrow={DropdownArrowOptions.}
      trigger={["click"]}
      icon={<DownOutlined />}
    >
      <PlusOutlined />
      {t(
        "Page.Configuration.TableSetup.Tabs.References.Labels.ActionAddReference",
        {
          lngs: i18n.languages,
          defaultValue: "ADD REFERENCE",
        }
      )}
    </Dropdown.Button>
  );

  const scrollMain = { x: 2000, y: "calc(100vh - 270px)" };

  const showViewData = () => {
    setIsTableViewDataLoading(true);
    let model: any = {
      groupcode: selectedViewDataGroupCode,
      entity: entities.find((x: any) => x.id === selectedEntity)?.name,
      operation: operations.find((x: any) => x.id === selectedOperation)?.name,
      tableName: selectedTable?.name,
      databaseName: selectedTable?.database,
      schemaName: selectedTable?.schema,
    };
    if (selectedViewDataRowsToShow !== "All") {
      model.rowsToShow = selectedViewDataRowsToShow;
    }

    TablesService.getToTableView(model)
      .then((response: any) => {
        setIsTableViewDataLoading(false);
        setTableViewData(response.data);
      })
      .catch((error: any) => {
        setIsTableViewDataLoading(false);
        setTableViewData([]);
        NotificationsUtil.openNotificationDialog({
          message: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      });
  };

  const downloadTableViewData = () => {
    setDownloadLoading(true);
    let model: any = {
      groupcode: selectedExportViewDataGroupCode,
      entity: entities.find((x: any) => x.id === selectedEntity)?.name,
      operation: operations.find((x: any) => x.id === selectedOperation)?.name,
      tableName: selectedTable?.name,
    };
    if (selectedExportViewDataRowsToShow !== "All") {
      model.rowsToShow = selectedExportViewDataRowsToShow;
    }
    TablesService.downloadTableViewData(model).then((response: any) => {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      saveAs(url, "tableViewData.xlsx");
      setShowViewExportDrawer(false);
      setDownloadLoading(false);
    });
  };

  useEffect(() => {
    if (selectedEntity && selectedTable) {
      showViewData();
    }
  }, [selectedViewDataGroupCode, selectedViewDataRowsToShow]);

  useEffect(() => {
    resetField();
    if (
      selectedOperation !== OPERATIONS.LEGACY &&
      selectedOperation !== OPERATIONS.VALIDATION &&
      selectedOperation !== OPERATIONS.LOADFILE
    ) {
      setFixedFields([]);
      setDraggableFields(fields);
      return;
    }

    // Hide system fields if preference is set
    var hideSystemFieldsPreference = preferences.find(
      (p) =>
        p.key === TABLE_SETUP_HIDE_SYSTEM_FIELDS &&
        p.object === "Application"
    );
    if (hideSystemFieldsPreference && hideSystemFieldsPreference.value !== "true") {
      setFixedFields(
        fields.filter(
          (item: any) =>
            item.isSystemField
        )
      );
    }

    setDraggableFields(
      fields.filter(
        (item: any) =>
          !item.isSystemField
      )
    );
  }, [fields]);

  useEffect(() => {
    if (tableViewData && tableViewData.length > 0) {
      const columnKeys = Object.keys(tableViewData[0]);
      setColumns(
        columnKeys.map((item: any) => ({
          title: item,
          dataIndex: item,
          key: item,
          width: 200,
          filters: [],
          fitlerMode: "tree",
          filterSearch: true,
          ellipsis: true,
        }))
      );
    }
  }, [tableViewData]);

  const onViewDataGroupCodeChange = (value: string) => {
    setSelectedViewDataGroupCode(value);
    setSelectedExportViewDataGroupCode(value);
    drawerForm.setFieldsValue({ viewDataGroupCode: value });
    exportForm.setFieldsValue({ exportViewDataGroupCode: value });
  };

  const onRecreateSelectedSourceOptionChange = (e: RadioChangeEvent) => {
    setRecreateSelectedSource(e.target.value);
  };

  // const onRecreateSelectedSourceOptionChange = (value: string) => {
  //   setRecreateSelectedSource(value);
  // };

  const onRecreateTableEntityChange = (value: string) => {
    setSelectedRecreateTableEntity(value);

    drawerForm.setFieldsValue({ recreateTableEntity: value });
  };

  const onRecreateTableOperationChange = (value: string) => {
    setSelectedRecreateTableOperation(value);
    drawerForm.setFieldsValue({ recreateTableOperation: value });
  };

  const onRecreateSelectedSourceEntityChange = (value: string) => {
    setRecreateSelectedSourceEntity(value);
    // onRecreateSelectedSourceOperationChange(undefined);
  };

  const onRecreateSelectedSourceOperationChange = (value: string) => {
    setRecreateSelectedSourceOperation(value);
    onRecreateSelectedSourceTableChange(undefined);
  };

  const onRecreateSelectedSourceTableChange = (value: string) => {
    setRecreateSelectedSourceTable(value);
    const table = recreateSelectedSourceTables.find((x: any) => x.id == value);

    setRecreateTableDatabase(table?.database);
    drawerForm.setFieldsValue({ recreateTableDatabase: table?.database });

    setRecreateTableSchema(table?.schema);
    drawerForm.setFieldsValue({ recreateTableSchema: table?.schema });
  };

  const onExportViewDataGroupCodeChange = (value: string) => {
    setSelectedExportViewDataGroupCode(value);
    exportForm.setFieldsValue({ exportViewDataGroupCode: value });
  };

  const showAdditionalOptions = () => {
    setAdditionalOptionsVisible(!additionalOptionsVisible);
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") {
      deleteTable();
    } else if (e.key === "2") {
      resetTable();
    } else {
      updateTable();
    }
  };

  const handleOpenRecreateTablePopConfirm = (newOpen: boolean) => {
    if (!newOpen) {
      setRecreateTablePopConfirmOpen(newOpen);
      return;
    }

    if (!isEditFieldsDirty) {
      handleRecreateTableClose();
    } else {
      setRecreateTablePopConfirmOpen(newOpen);
    }
  }

  const downloadRecreateTableExcel = () => {
    const model: any = {
      operationId: selectedOperation,
      recreateTableFields: [],
    };

    TablesService.downloadRecreateTableExcel(model).then((response: any) => {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      saveAs(url, "table.xlsx");
    });
  };

  const dropdownMenu = (
    <Menu
      // className="twoFoldMenu"
      style={{ padding: "10px" }}
      selectable
      onClick={handleMenuClick}
      items={[
        // {
        //   label: t(
        //     "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.AdditionalOptionDelete",
        //     {
        //       lngs: i18n.languages,
        //       defaultValue: "Delete",
        //     }
        //   ),
        //   key: "1",
        //   icon: <DeleteOutlined />,
        // },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.AdditionalOptionReset",
            {
              lngs: i18n.languages,
              defaultValue: "Reset",
            }
          ),
          key: "2",
          icon: <SyncOutlined />,
        },
        {
          label: t(
            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.AdditionalOptionUpdate",
            {
              lngs: i18n.languages,
              defaultValue: "Update",
            }
          ),
          key: "3",
          icon: <CheckOutlined />,
        },
      ]}
    />
  );

  useEffect(() => {
    if (showEditFieldsDrawer) {
      onRecreateTableEntityChange(selectedEntity);
      onRecreateTableOperationChange(selectedOperation);
      onRecreateSelectedSourceEntityChange(selectedEntity);
      onRecreateSelectedSourceOperationChange(selectedOperation);
      // onRecreateSelectedSourceTableChange(selectedTable.id);

      recreateForm.setFieldsValue({
        selectRecreateSource: "existingTable",
        selectRecreateSourceEntity: selectedEntity,
        selectRecreateSourceOperation: selectedOperation,
        selectRecreateSourceTable: undefined,
      });

      recreateForm.setFieldsValue({
        selectRecreateSource: "blankTable",
      });
    }
  }, [showEditFieldsDrawer]);

  type MenuItem = Required<MenuProps>["items"][number];

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const getIcon = (typeId: number) => {
    if (typeId) {
      const type = fieldTypes.find((x: any) => x.id === typeId);

      if (type?.iconUrl) {
        const AntIcon = React.lazy(
          () => import(`@ant-design/icons/es/icons/${type.iconUrl}.js`)
        );
        return (
          <IconErrorBoundary fallback={<div></div>}>
            <Suspense fallback={<div></div>}>
              <AntIcon style={{ paddingLeft: 5 }} />
            </Suspense>
          </IconErrorBoundary>
        );
      }

      return (
        <Suspense fallback={<div></div>}>
        </Suspense>
      );
    }
  };

  const renderItems = (items: any) => {
    return items
      .map((item: any) =>
        getItem(
          <>
            {item?.label?.length > 25
              ? item?.label?.slice(0, 25) + "..."
              : item?.label}
            {item.icon}
          </>,
          item.key,
          null,
          null,
          null
        )
      );
  };

  useEffect(() => {
    let mappedFields = fixedFields
      .sort(function (a: any, b: any) {
        return a.position - b.position;
      })
      .map((item: any) => {
        return {
          key: item.id,
          label: item.name,
          typeId: item.typeId,
          icon: item.icon,
        };
      });

    setFixedFieldsRender(renderItems(mappedFields));
  }, [fixedFields, fieldTypes]);

  const technicalFieldsForOperation = {
    [OPERATIONS.LEGACY]: ["code", "groupcode", "run_date", "deltastatus", "mod_dt_all", "sourcedata"],
    [OPERATIONS.VALIDATION]: ["code", "groupcode", "environment"],
    [OPERATIONS.LOADFILE]: ["code", "groupcode", "system", "environment"],
  };

  const isTechnicalField = () => {
    const technicalFields = technicalFieldsForOperation[selectedOperation] || [];
    return technicalFields.includes(selectedField.name.toLowerCase());
  };

  return (
    <div>
      <PageHead
        title={t("Page.Configuration.TableSetup.Headers.TableSetup", {
          lngs: i18n.languages,
          defaultValue: "Table setup",
        })}
        icon={<TableOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={
          searchParams.get("tab") &&
            searchParams.get("tab") === "table-setup" &&
            selectedOperation !== OPERATIONS.IMPORT
            ? true
            : searchParams.get("tab") &&
              searchParams.get("tab") === "table-setup" &&
              selectedOperation === OPERATIONS.IMPORT
              ? false
              : searchParams.get("tab") &&
                searchParams.get("tab") === "translations"
                ? false
                : searchParams.get("tab") &&
                  searchParams.get("tab") === "references"
                  ? true
                  : true
        }
        setSelectEntityDisabled={
          searchParams.get("tab") && searchParams.get("tab") === "table-setup"
            ? false
            : searchParams.get("tab") &&
              searchParams.get("tab") === "translations"
              ? true
              : searchParams.get("tab") &&
                searchParams.get("tab") === "references"
                ? true
                : true
        }
        setSelectOperationDisabled={
          searchParams.get("tab") && searchParams.get("tab") === "table-setup"
            ? false
            : searchParams.get("tab") &&
              searchParams.get("tab") === "translations"
              ? true
              : searchParams.get("tab") &&
                searchParams.get("tab") === "references"
                ? true
                : true
        }
        mainAction={
          searchParams.get("tab")
            ? searchParams.get("tab") === "translations"
              ? actionButtonTranslations
              : searchParams.get("tab") === "references"
                ? actionButtonReferences
                : undefined
            : undefined
        }
        otherActions={[]}
        setActionsDisabled={false}
      />
      <div className="card-container">
        <Tabs
          type="card"
          activeKey={searchParams.get("tab") ? searchParams.get("tab")! : ""}
          onChange={onTabChange}
          style={{ height: "100%" }}
        >
          <TabPane
            tab={t("Page.Configuration.TableSetup.Tabs.Tablesetup", {
              lngs: i18n.languages,
              defaultValue: "Overview"
            })}
            key="table-setup"
          >
            <div className="table-setup-tab-container">
              <div className="section-container-sm">
                <div className="section-header">
                  <Select
                    ref={tableRef}
                    disabled={
                      !selectedEntity ||
                      // !selectedGroupCode ||
                      !selectedOperation
                    }
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    value={selectedTable?.id}
                    onChange={handleTableChange}
                    style={{ flex: 2, width: "85%" }}
                    dropdownMatchSelectWidth={false}
                    placeholder={t(
                      "Page.Configuration.TableSetup.Tabs.TableSetup.Placeholders.SelectTable",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Table",
                      }
                    )}
                    optionFilterProp="children"
                    filterOption={(inputValue, option) => {
                      const label = option!.label as unknown as JSX.Element;
                      const text = label.props.children[0].props.children;
                      return text.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
                    }}
                  // filterSort={(optionA, optionB) =>
                  //   (optionA!.children as unknown as string)
                  //     .toLowerCase()
                  //     .localeCompare(
                  //       (optionB!.children as unknown as string).toLowerCase()
                  //     )
                  // }
                  >
                    {selectedOperation === OPERATIONS.IMPORT
                      ? tables
                        .filter((x: any) =>
                          selectedGroupCode
                            ? x.groupCode === selectedGroupCode
                            : x.groupCode === x.groupCode
                        )
                        .map((item: any) => {
                          return <Option value={item.id}>
                            <div style={{ justifyContent: "space-between", display: "flex" }}>
                              <span>{item.name}</span> {item.tableType === 'VIEW' ?
                                (<img src={viewIcon} alt="View" width={12} />) :
                                (<img src={tableIcon} alt="Table" width={12} />)}
                            </div>
                          </Option>
                        })
                      : tables.map((item: any) => {
                        return <Option value={item.id}>{item.name}</Option>;
                      })}
                  </Select>
                  {selectedOperation === OPERATIONS.LEGACY || selectedOperation === OPERATIONS.VALIDATION ? (
                    ""
                  ) : (
                    <Button
                      disabled={
                        !selectedEntity ||
                        // !selectedGroupCode ||
                        !selectedOperation
                      }
                      onClick={onAddTableClick}
                      icon={<PlusOutlined />}
                    />
                  )}
                </div>
                <Divider />
                <div className="section-items">
                  {selectedEntity && selectedOperation && !isTableLoading ? (
                    <Menu
                      items={
                        selectedOperation === OPERATIONS.IMPORT
                          ? tables
                            .filter((x: any) =>
                              selectedGroupCode
                                ? x.groupCode === selectedGroupCode
                                : x.groupCode === x.groupCode
                            )
                            .map((item: any) => {
                              return {
                                key: item.id,
                                label: (
                                  <div style={{ justifyContent: "space-between", display: "flex" }}><span>{item.name}</span> {item.tableType === 'VIEW' ? (<img src={viewIcon} alt="View" width={12} />) :
                                    (<img src={tableIcon} alt="Table" width={12} />)}</div>
                                ),
                              };
                            })
                          : tables.map((item: any) => {
                            return {
                              key: item.id,
                              label: item.name,
                            };
                          })
                      }
                      selectedKeys={[
                        selectedTable?.id === "New table"
                          ? "New table"
                          : selectedTable?.id
                            ? selectedTable.id.toString()
                            : ""
                      ]}
                      onClick={handleTableMenuClick}
                    />
                  ) : (
                    <Empty
                      description={
                        (!selectedEntity || !selectedOperation) &&
                        t("Page.Configuration.TableSetup.Headers.TableSetup", {
                          lngs: i18n.languages,
                          defaultValue:
                            "Please select an Entity and Operation to get started",
                        })
                      }
                    ></Empty>
                  )}
                  {isTableLoading && (
                    <div className={styles.loadingContainer}>
                      <Spin />
                    </div>
                  )}
                </div>
              </div>
              <Modal
                title="Import fields"
                visible={showOptionsModal}
                onOk={handleRecreateTableOk}
                // onCancel={handleCancel}
                cancelButtonProps={{ style: { display: 'none' } }}
                width="50vw"
              >
                <Form layout="vertical" form={recreateForm}>
                  <div style={{ marginBottom: 20 }}>
                    {t(
                      "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.RecreateTable.Modal.Labels.TableCreatedSuccessfully",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Table created successfully.",
                      }
                    )}
                  </div>
                  <Form.Item
                    name="selectRecreateSource"
                    label={t(
                      "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.RecreateTable.Modal.Labels.SetupTableFields",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Setup table fields:",
                      }
                    )}
                  >
                    <Radio.Group name="setupTableFields" defaultValue="blankTable" value={recreateSelectedSource} onChange={onRecreateSelectedSourceOptionChange}>
                      <Space direction="vertical">
                        <Radio value="blankTable">Blank start, don't import fields</Radio>
                        <Radio value="existingTable">Copy fields from existing table</Radio>
                        <Radio value="excelFile">Import fields from excel template</Radio>
                      </Space>
                    </Radio.Group>
                    {/*  <Select*/}
                    {/*    showSearch={true}*/}
                    {/*    showArrow={true}*/}
                    {/*    allowClear={true}*/}
                    {/*    placeholder={*/}
                    {/*      t("General.Placeholders.SelectOption", {*/}
                    {/*        lngs: i18n.languages,*/}
                    {/*        defaultValue: "Select option",*/}
                    {/*      })!*/}
                    {/*    }*/}
                    {/*    onChange={onRecreateSelectedSourceOptionChange}*/}
                    {/*    options={[*/}
                    {/*      {*/}
                    {/*        value: "blankTable",*/}
                    {/*        label: "Blank start, don't import fields",*/}
                    {/*      },*/}
                    {/*      {*/}
                    {/*        value: "existingTable",*/}
                    {/*        label: "Copy fields from existing table",*/}
                    {/*      },*/}
                    {/*      {*/}
                    {/*        value: "excelFile",*/}
                    {/*        label: "Import fields from excel template",*/}
                    {/*      },*/}
                    {/*    ]}*/}
                    {/*    value={recreateSelectedSource}*/}
                    {/*  ></Select>*/}
                  </Form.Item>
                  {recreateSelectedSource === "existingTable" && (
                    <>
                      <Form.Item
                        name="selectRecreateSourceEntity"
                        style={{ width: "200px" }}
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.RecreateTable.Modal.Labels.SelectEntity",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Select entity:",
                          }
                        )}
                      >
                        <Select
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          placeholder={
                            t("General.Placeholders.SelectOption", {
                              lngs: i18n.languages,
                              defaultValue: "Select option",
                            })!
                          }
                          onChange={onRecreateSelectedSourceEntityChange}
                          onClear={() =>
                            onRecreateSelectedSourceOperationChange(undefined)
                          }
                          options={entities.map((item: any) => {
                            return {
                              value: item.id,
                              label: item.name,
                            };
                          })}
                          value={recreateSelectedSourceEntity}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                              .toLowerCase()
                              .localeCompare(
                                (
                                  optionB!.label as unknown as string
                                ).toLowerCase()
                              )
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        name="selectRecreateSourceOperation"
                        style={{ width: "200px" }}
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.RecreateTable.Modal.Labels.SelectOperation",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Select operation:",
                          }
                        )}
                      >
                        <Select
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          placeholder={
                            t("General.Placeholders.SelectOption", {
                              lngs: i18n.languages,
                              defaultValue: "Select option",
                            })!
                          }
                          onChange={onRecreateSelectedSourceOperationChange}
                          onClear={() =>
                            onRecreateSelectedSourceTableChange(undefined)
                          }
                          options={operations
                            .filter((item: any) => item.name !== "Enrichment")
                            .map((item: any) => {
                              return {
                                value: item.id,
                                label: item.name,
                              };
                            })}
                          value={recreateSelectedSourceOperation}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                              .toLowerCase()
                              .localeCompare(
                                (
                                  optionB!.label as unknown as string
                                ).toLowerCase()
                              )
                          }
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        name="selectRecreateSourceTable"
                        style={{ width: "200px" }}
                        label={t(
                          "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.RecreateTable.Modal.Labels.SelectTable",
                          {
                            lngs: i18n.languages,
                            defaultValue: "Select table:",
                          }
                        )}
                      >
                        <Select
                          showSearch={true}
                          showArrow={true}
                          allowClear={true}
                          placeholder={
                            t("General.Placeholders.SelectOption", {
                              lngs: i18n.languages,
                              defaultValue: "Select option",
                            })!
                          }
                          onChange={onRecreateSelectedSourceTableChange}
                          options={recreateSelectedSourceTables?.map(
                            (item: any) => {
                              return {
                                value: item.id,
                                label: item.name,
                              };
                            }
                          )}
                          value={recreateSelectedSourceTable}
                          filterOption={(inputValue: any, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA!.label as unknown as string)
                              .toLowerCase()
                              .localeCompare(
                                (
                                  optionB!.label as unknown as string
                                ).toLowerCase()
                              )
                          }
                        ></Select>
                      </Form.Item>
                    </>
                  )}
                  {recreateSelectedSource === "excelFile" && (
                    <Form.Item
                      name="downloadTemplate"
                      style={{ width: "200px" }}
                      label={t(
                        "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.RecreateTable.Modal.Labels.DownloadTemplate",
                        {
                          lngs: i18n.languages,
                          defaultValue: "Download template:",
                        }
                      )}
                    >
                      <Button
                        icon={<DownloadOutlined />}
                        size="small"
                        type="ghost"
                        onClick={downloadRecreateTableExcel}
                      >
                        {t("General.Labels.Download", {
                          lngs: i18n.languages,
                          defaultValue: "Download",
                        })}
                      </Button>
                    </Form.Item>
                  )}
                  {recreateSelectedSource === "excelFile" && (
                    <Form.Item
                      name="selectFile"
                      style={{ width: "200px" }}
                      label={t(
                        "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.RecreateTable.Modal.Labels.SelectFile",
                        {
                          lngs: i18n.languages,
                          defaultValue: "Select file to use as template:",
                        }
                      )}
                    >
                      <Upload
                        fileList={
                          recreateSelectedUploadFile
                            ? [recreateSelectedUploadFile]
                            : []
                        }
                        onChange={handleUploadFileChange}
                        beforeUpload={preventRequest}
                        customRequest={customRequest}
                        // onChange={handleUploadFileChange}
                        // beforeUpload={preventRequest}
                        // customRequest={customRequest}
                        accept=".xls,.xlsx"
                      >
                        <Button
                          icon={<UploadOutlined />}
                          size="small"
                          type="ghost"
                        >
                          {t("General.Labels.Upload", {
                            lngs: i18n.languages,
                            defaultValue: "Upload",
                          })}
                        </Button>
                      </Upload>
                    </Form.Item>
                  )}
                </Form>
              </Modal>
              <div className="section-container-sm">
                <div className="section-header">
                  <Select
                    disabled={!selectedTable || selectedTable.id === "New table"}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    value={selectedField?.id}
                    onChange={handleFieldChange}
                    style={{ flex: 2, width: "85%" }}
                    dropdownMatchSelectWidth={false}
                    placeholder={t("Page.Configuration.TableSetup.Tabs.TableSetup.Placeholders.SelectField", {
                      lngs: i18n.languages,
                      defaultValue: "Field",
                    })}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                      String(optionA!.children).toLowerCase().localeCompare(String(optionB!.children).toLowerCase())
                    }
                  >
                    {fields
                      .sort((a: any, b: any) => a.position - b.position)
                      .map((item: any) => (
                        <Option value={item.id} key={item.id}>

                          {item.name}

                        </Option>
                      ))}
                  </Select>
                  <Button
                    disabled={
                      !selectedTable || selectedTable.id === "New table"
                    }
                    onClick={onAddFieldClick}
                    icon={<PlusOutlined />}
                  />
                </div>
                <Divider />
                <div className="section-items">
                  {selectedTable &&
                    selectedTable.id !== "New table" &&
                    !isFieldsLoading ? (
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                      <Droppable droppableId="DropId">
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            <Menu
                              items={fixedFieldsRender}
                              selectedKeys={[selectedField?.id.toString()]}
                              onClick={(item: any) =>
                                handleFieldMenuClick(item.key)
                              }
                              style={{ marginRight: "5px" }}
                            />
                            {draggableFields && draggableFields.length > 0 && (
                              <List
                                // className={selectedField?.id === item.key ? "fieldMenu selectedField" : "fieldMenu"}
                                rowKey={(item: any) => item?.key}
                                dataSource={draggableFields
                                  .sort(function (a: any, b: any) {
                                    return a.position - b.position;
                                  })
                                  .map((item: any) => {
                                    return {
                                      key: item.id,
                                      label: item.name,
                                      typeId: item.typeId,
                                      icon: item.icon,
                                      isKey: item.isKey
                                    };
                                  })}
                                size="small"
                                // onClick={handleFieldMenuClick}
                                renderItem={(item: any, index: any) => (
                                  <Draggable
                                    draggableId={`draggable-${index}`}
                                    index={index}
                                    isDragDisabled={item.label === "Code"}
                                  >
                                    {(provided) => (
                                      <div
                                        className={
                                          selectedField?.id === item.key
                                            ? "fieldMenu selectedField"
                                            : "fieldMenu"
                                        }
                                        ref={provided.innerRef}
                                        onClick={() =>
                                          handleFieldMenuClick(item.key)
                                        }
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <List.Item>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              alignItems: "center",
                                              width: "100%",
                                              textOverflow: "ellipsis",
                                              overflowX: "hidden",
                                            }}
                                          >
                                            {item?.label?.length > 25
                                              ? item?.label?.slice(0, 25) +
                                              "..."
                                              : item?.label}
                                            {item?.icon}
                                            {item?.isKey && (<KeyOutlined />)}
                                          </div>
                                        </List.Item>
                                      </div>
                                    )}
                                  </Draggable>
                                )}
                              />
                            )}

                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  ) : (
                    <Empty description={false} />
                  )}
                  {isFieldsLoading && (
                    <div className={styles.loadingContainer}>
                      <Spin />
                    </div>
                  )}
                </div>
              </div>
              {selectedTable || selectedField ? (
                <div
                  className={
                    selectedTable && selectedField
                      ? "form-containers section-container-lg form-expanded"
                      : "form-containers section-container-lg form-expanded"
                  }
                >
                  {selectedTable && selectedTable.id !== "New table" && (
                    <div>
                      <div className="title-actions">
                        <Breadcrumb>
                          <Breadcrumb.Item>
                            {selectedTable?.name?.length > 30
                              ? selectedTable?.name.slice(0, 30) + "..."
                              : selectedTable?.name}
                          </Breadcrumb.Item>
                          <Breadcrumb.Item>
                            {t(
                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.UpdateTable",
                              {
                                lngs: i18n.languages,
                                defaultValue: "Update table",
                              }
                            )}
                          </Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="action-buttons">
                          {selectedOperation === OPERATIONS.LEGACY ||
                            selectedOperation === OPERATIONS.VALIDATION ? (
                            <>
                              <Tooltip
                                title={
                                  !userHasPermissions.write
                                    ? "You don't have sufficient permissions to perform this action."
                                    : ""
                                }
                              >
                                <Button
                                  // type="ghost"
                                  size="small"
                                  style={{ padding: "0px 2px" }}
                                  onClick={handleRecreateTableClick}
                                  icon={<EditOutlined />}
                                  disabled={
                                    isFieldsLoading || !userHasPermissions.write
                                  }
                                  loading={isFieldsLoading}
                                >
                                  {t("General.Labels.EditFields", {
                                    lngs: i18n.languages,
                                    defaultValue: "Edit fields",
                                  })}
                                </Button>
                              </Tooltip>
                              <Dropdown.Button
                                type="ghost"
                                size="small"
                                overlay={dropdownMenu}
                                onClick={handleViewClick}
                              >
                                View
                              </Dropdown.Button>
                            </>
                          ) : (
                            <>
                              <Tooltip
                                title={
                                  !userHasPermissions.write
                                    ? "You don't have sufficient permissions to perform this action."
                                    : ""
                                }
                              >
                                <Button
                                  // type="ghost"
                                  size="small"
                                  style={{ padding: "0px 10px", marginRight: "5px" }}
                                  onClick={handleScanTable}
                                  disabled={
                                    isFieldsLoading || !userHasPermissions.write
                                  }
                                  loading={isFieldsLoading}
                                >
                                  {t("General.Labels.EditFields", {
                                    lngs: i18n.languages,
                                    defaultValue: "Scan Table",
                                  })}
                                </Button>

                                <Button
                                  // type="ghost"
                                  size="small"
                                  style={{ padding: "0px 2px" }}
                                  onClick={handleRecreateTableClick}
                                  icon={<EditOutlined />}
                                  disabled={
                                    isFieldsLoading || !userHasPermissions.write
                                  }
                                  loading={isFieldsLoading}
                                >
                                  {t("General.Labels.EditFields", {
                                    lngs: i18n.languages,
                                    defaultValue: "Edit fields",
                                  })}
                                </Button>
                              </Tooltip>
                              <Button
                                type="ghost"
                                size="small"
                                style={{ padding: "0px 2px" }}
                                onClick={handleViewClick}
                                icon={<EyeOutlined />}
                                disabled={isFieldsLoading}
                                loading={isFieldsLoading}
                              >
                                {t("General.Labels.View", {
                                  lngs: i18n.languages,
                                  defaultValue: "View",
                                })}
                              </Button>
                              <Tooltip
                                title={
                                  !userHasPermissions.delete
                                    ? "You don't have sufficient permissions to perform this action."
                                    : ""
                                }
                              >
                                <Popconfirm
                                  style={{ width: "400px" }}
                                  placement="topRight"
                                  title={
                                    <div
                                      style={{
                                        width: "400px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Popups.DeleteTable",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue:
                                            "Are you really sure that you want to delete this table? This will delete all migration rules, mappings, and fields related to the table as well.",
                                        }
                                      )}
                                    </div>
                                  }
                                  icon={
                                    <QuestionCircleOutlined
                                      style={{ color: "red" }}
                                    />
                                  }
                                  onConfirm={() => deleteTable()}
                                  // onCancel={() => cancel}
                                  okText={t("General.Actions.Yes", {
                                    lngs: i18n.languages,
                                    defaultValue: "Yes",
                                  })}
                                  cancelText={t("General.Actions.No", {
                                    lngs: i18n.languages,
                                    defaultValue: "No",
                                  })}
                                  disabled={!userHasPermissions.delete || selectedTable?.name === "Loadfile"}
                                >
                                  <Button
                                    // type="ghost" 
                                    size="small"
                                    className={
                                      userHasPermissions.delete
                                        ? styles.dangerColor
                                        : styles.disabledColor
                                    }
                                    style={{ padding: "0px 2px" }}
                                    icon={
                                      <DeleteOutlined
                                        className={
                                          userHasPermissions.delete && selectedTable?.name !== "Loadfile"
                                            ? styles.dangerColor
                                            : styles.disabledColor
                                        }
                                      />
                                    }
                                    disabled={!userHasPermissions.delete || selectedTable?.name === "Loadfile"}
                                  >
                                    {t("General.Labels.Delete", {
                                      lngs: i18n.languages,
                                      defaultValue: "Delete",
                                    })}
                                  </Button>
                                </Popconfirm>
                              </Tooltip>
                              <Button
                                onClick={resetTable}
                                type="ghost"
                                size="small"
                                icon={<SyncOutlined />}
                              >
                                {t("General.Labels.Reset", {
                                  lngs: i18n.languages,
                                  defaultValue: "Reset",
                                })}
                              </Button>
                              <Tooltip
                                title={
                                  !userHasPermissions.write
                                    ? "You don't have sufficient permissions to perform this action."
                                    : ""
                                }
                              >
                                <Button
                                  className={
                                    updateTableAllowed ? "update-btn" : ""
                                  }
                                  disabled={!updateTableAllowed}
                                  onClick={updateTable}
                                  size="small"
                                  icon={<CheckOutlined />}
                                  loading={updateTableLoading}
                                >
                                  {t("General.Labels.Update", {
                                    lngs: i18n.languages,
                                    defaultValue: "Update",
                                  })}
                                </Button>
                              </Tooltip>
                            </>
                          )}
                        </div>
                      </div>
                      <Divider />
                      <div className="form-content">
                        <div>
                          <Form layout="vertical" size="small">
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableDatabase",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Database:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableDatabase",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                              required={true}
                            >
                              <Select
                                disabled={true}
                                showSearch={true}
                                showArrow={true}
                                allowClear={true}
                                placeholder={
                                  t("General.Placeholders.SelectOption", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select option",
                                  })!
                                }
                                filterSort={(optionA, optionB) =>
                                  (optionA.value as string).localeCompare(optionB.value as string)
                                }
                                value={selectedTable?.database}
                                onChange={onSelectedTableDatabaseChange}
                                options={databases.map((x: any) => ({
                                  label: x.name,
                                  value: x.name,
                                }))}
                              ></Select>
                              {/* <Input
                                placeholder="Enter value"
                                value={selectedTable?.database}
                                onChange={onSelectedTableDatabaseChange}
                              /> */}
                            </Form.Item>
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableSchema",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Schema:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableSchema",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                              required={true}
                            >
                              <Input
                                disabled={true}
                                placeholder={
                                  t("General.Placeholders.EnterValue", {
                                    lngs: i18n.languages,
                                    defaultValue: "Enter value",
                                  })!
                                }
                                value={selectedTable?.schema}
                                onChange={onSelectedTableSchemaChange}
                              />
                            </Form.Item>
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableName",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Name:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableName",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                              required={true}
                            >
                              <Input
                                placeholder={
                                  t("General.Placeholders.EnterValue", {
                                    lngs: i18n.languages,
                                    defaultValue: "Enter value",
                                  })!
                                }
                                value={selectedTable?.name}
                                maxLength={128}
                                onChange={onSelectedTableNameChange}
                              />
                            </Form.Item>
                            {selectedOperation === OPERATIONS.LOADFILE && (
                              <Checkbox
                                checked={selectedTable?.onlyValidateFieldsInCurrentLoadfile}
                                onChange={onSelectedTableonlyValidateFieldsInCurrentLoadfile}
                                style={{ marginLeft: 0 }}
                              >
                                {t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.onlyValidateFieldsInCurrentLoadfile",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue:
                                      "Only validate fields in Loadfile",
                                  }
                                )}
                              </Checkbox>
                            )}

                            {selectedOperation === OPERATIONS.IMPORT && (
                              <Checkbox
                                checked={selectedTable?.importFreeze}
                                onChange={onSelectedTableImportFreeze}
                                style={{ marginLeft: 0 }}
                              >
                                {t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ImportFreeze",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue:
                                      "Import Freeze",
                                  }
                                )}
                              </Checkbox>
                            )}

                          </Form>
                        </div>
                        <div>
                          <Form layout="vertical" size="small">
                            {selectedOperation === OPERATIONS.IMPORT ? (
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableGroupCode",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Group Code:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableGroupCode",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                                required={true}
                              >
                                <Select
                                  showSearch={true}
                                  showArrow={true}
                                  value={
                                    selectedOperation === OPERATIONS.IMPORT
                                      ? selectedTable?.groupCode ??
                                      selectedGroupCode
                                      : selectedTable?.groupCode
                                  }
                                  onChange={onSelectedTableGroupCodeChange}
                                  options={groupCodes.map((x: any) => ({
                                    label: x.code,
                                    value: x.code,
                                  }))}
                                  filterSort={(optionA, optionB) =>
                                    optionA.value! < optionB.value! ? -1 : 1
                                  }
                                ></Select>
                              </Form.Item>
                            ) : (
                              <></>
                            )}
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "System:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                            >
                              <Select
                                showSearch
                                options={systems.map((x: System) => ({
                                  label: x.name,
                                  value: x.id,
                                }))}
                                filterOption={(input, option) =>
                                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                value={selectedTable?.systemId}
                                onChange={onSelectedTableSystemChange}
                                allowClear
                                placeholder={t("General.Placeholders.SelectOption", {
                                  lngs: i18n.languages,
                                  defaultValue: "Select option",
                                })!}
                              >
                              </Select>
                            </Form.Item>
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableDescription",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Description:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableDescription",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                            >
                              <TextArea
                                value={selectedTable?.description}
                                placeholder={
                                  t("General.Placeholders.EnterValue", {
                                    lngs: i18n.languages,
                                    defaultValue: "Enter value",
                                  })!
                                }
                                rows={selectedOperation === OPERATIONS.IMPORT ? 5 : 6}
                                allowClear
                                onChange={onSelectedTableDescriptionChange}
                                maxLength={250}
                              />
                            </Form.Item>

                          </Form>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedTable && selectedTable.id === "New table" && (
                    <div>
                      <div className="title-actions">
                        <Breadcrumb>
                          {/* <Breadcrumb.Item>{selectedTable?.label}</Breadcrumb.Item> */}
                          <Breadcrumb.Item>
                            {t(
                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.NewTable",
                              {
                                lngs: i18n.languages,
                                defaultValue: "New table",
                              }
                            )}
                          </Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="action-buttons">
                          <Button
                            type="ghost"
                            size="small"
                            onClick={resetTable}
                            icon={<SyncOutlined />}
                          >
                            {t("General.Labels.Reset", {
                              lngs: i18n.languages,
                              defaultValue: "Reset",
                            })}
                          </Button>
                          <Tooltip
                            title={
                              !userHasPermissions.write
                                ? "You don't have sufficient permissions to perform this action."
                                : ""
                            }
                          >
                            <Button
                              className={updateTableAllowed ? "update-btn" : ""}
                              disabled={!updateTableAllowed}
                              onClick={createTable}
                              size="small"
                              icon={<CheckOutlined />}
                              loading={createTableLoading}
                            >
                              {t("General.Labels.Create", {
                                lngs: i18n.languages,
                                defaultValue: "Create",
                              })}
                            </Button>
                          </Tooltip>
                        </div>
                      </div>
                      <Divider />
                      <div className="form-content">
                        <div>
                          <Form layout="vertical" size="small">
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableDatabase",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Database:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableDatabase",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                              required={true}
                            >
                              <Select
                                ref={databaseRef}
                                placeholder={
                                  t("General.Placeholders.SelectOption", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select option",
                                  })!
                                }
                                showSearch={true}
                                showArrow={true}
                                allowClear={true}
                                value={selectedTable?.database}
                                onChange={onSelectedTableDatabaseChange}
                                options={databases.map((x: any) => ({
                                  label: x.name,
                                  value: x.name,
                                }))}
                                defaultValue={
                                  defaultDatabase
                                    ? defaultDatabase
                                    : databases.length === 1
                                      ? databases[0].name
                                      : null
                                }
                                filterSort={(optionA, optionB) =>
                                  (optionA.value as string).localeCompare(optionB.value as string, undefined, { sensitivity: "base" })
                                }

                              ></Select>
                            </Form.Item>
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableSchema",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Schema:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableSchema",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                              required={true}
                            >
                              <Input
                                placeholder={
                                  t("General.Placeholders.EnterValue", {
                                    lngs: i18n.languages,
                                    defaultValue: "Enter value",
                                  })!
                                }
                                value={selectedTable?.schema}
                                onChange={onSelectedTableSchemaChange}
                              />
                            </Form.Item>
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableName",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Name:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableName",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                              required={true}
                            >
                              <Input
                                placeholder={
                                  t("General.Placeholders.EnterValue", {
                                    lngs: i18n.languages,
                                    defaultValue: "Enter value",
                                  })!
                                }
                                value={selectedTable?.name}
                                maxLength={128}
                                onChange={onSelectedTableNameChange}
                              />
                            </Form.Item>
                            {selectedOperation === OPERATIONS.LOADFILE && (
                              <Checkbox
                                checked={selectedTable?.onlyValidateFieldsInCurrentLoadfile}
                                onChange={onSelectedTableonlyValidateFieldsInCurrentLoadfile}
                                style={{ marginLeft: 0 }}
                              >
                                {t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.onlyValidateFieldsInCurrentLoadfile",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue:
                                      "Only validate fields in Loadfile",
                                  }
                                )}
                              </Checkbox>
                            )}
                            {selectedOperation === OPERATIONS.IMPORT && (
                              <Checkbox
                                checked={selectedTable?.importFreeze}
                                onChange={onSelectedTableImportFreeze}
                                style={{ marginLeft: 0 }}
                              >
                                {t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ImportFreeze",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue:
                                      "Import Freeze",
                                  }
                                )}
                              </Checkbox>
                            )}
                          </Form>
                        </div>
                        <div>
                          <Form layout="vertical" size="small">
                            {selectedOperation === OPERATIONS.IMPORT ? (
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableGroupCode",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Group Code:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableGroupCode",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                                required={true}
                              >
                                <Select
                                  showSearch={true}
                                  showArrow={true}
                                  value={
                                    selectedOperation === OPERATIONS.IMPORT
                                      ? selectedTable?.groupCode ??
                                      selectedGroupCode
                                      : selectedTable?.groupCode
                                  }
                                  onChange={onSelectedTableGroupCodeChange}
                                  options={groupCodes.map((x: any) => ({
                                    label: x.code,
                                    value: x.code,
                                  }))}
                                  filterSort={(optionA, optionB) =>
                                    optionA.value! < optionB.value! ? -1 : 1
                                  }
                                ></Select>
                              </Form.Item>
                            ) : (
                              <></>
                            )}
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "System:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                            >
                              <Select
                                showSearch
                                filterOption={(input, option) =>
                                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={systems.map((x: System) => ({
                                  label: x.name,
                                  value: x.id,
                                }))}
                                value={selectedTable?.systemId}
                                onChange={onSelectedTableSystemChange}
                                allowClear
                                placeholder={t("General.Placeholders.SelectOption", {
                                  lngs: i18n.languages,
                                  defaultValue: "Select option",
                                })!}
                              >
                              </Select>
                            </Form.Item>
                            <Form.Item
                              label={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.TableDescription",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Description:",
                                }
                              )}
                              tooltip={t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.TableDescription",
                                { lngs: i18n.languages, defaultValue: "" }
                              )}
                            >
                              <TextArea
                                value={selectedTable?.description}
                                placeholder={
                                  t("General.Placeholders.EnterValue", {
                                    lngs: i18n.languages,
                                    defaultValue: "Enter value",
                                  })!
                                }
                                rows={selectedOperation === OPERATIONS.IMPORT ? 5 : 6}
                                allowClear
                                onChange={onSelectedTableDescriptionChange}
                                maxLength={250}
                              />
                            </Form.Item>
                          </Form>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedTable &&
                    selectedTable.id !== "New table" &&
                    selectedField &&
                    selectedField.id !== "New field" && (
                      <div>
                        <div className="title-actions">
                          <Breadcrumb>
                            <Breadcrumb.Item>
                              {selectedField?.name?.length > 25
                                ? selectedField?.name.slice(0, 25) + "..."
                                : selectedField?.name}
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                              {t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.UpdateField",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "Update field",
                                }
                              )}
                            </Breadcrumb.Item>
                          </Breadcrumb>
                          <div className="action-buttons">
                            {selectedOperation === OPERATIONS.VALIDATION && (
                              <Button
                                type={isTechnicalField() ? "default" : "ghost"}
                                // disabled={updateFieldAllowed}
                                onClick={showAdditionalOptions}
                                size="small"
                                // icon={<CheckOutlined />}
                                loading={updateFieldLoading}
                                disabled={isTechnicalField()}
                              >
                                {t("General.Labels.AdvancedOptions", {
                                  lngs: i18n.languages,
                                  defaultValue: "Advanced Options",
                                })}
                              </Button>
                            )}
                            <Tooltip
                              title={
                                !userHasPermissions.delete
                                  ? "You don't have sufficient permissions to perform this action."
                                  : ""
                              }
                            >
                              <Popconfirm
                                placement="topRight"
                                title={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Popups.DeleteField",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue:
                                      "Are you sure you want to delete this field?",
                                  }
                                )}
                                icon={
                                  <QuestionCircleOutlined
                                    style={{ color: "red" }}
                                  />
                                }
                                onConfirm={() => deleteField()}
                                // onCancel={() => cancel}
                                okText={t("General.Actions.Yes", {
                                  lngs: i18n.languages,
                                  defaultValue: "Yes",
                                })}
                                cancelText={t("General.Actions.No", {
                                  lngs: i18n.languages,
                                  defaultValue: "No",
                                })}
                                disabled={!userHasPermissions.delete || isTechnicalField()}
                              >
                                <Button
                                  // type="text"
                                  disabled={!userHasPermissions.delete || isTechnicalField()}
                                  size="small"
                                  hidden={selectedTable?.tableType === 'VIEW'}
                                  className={
                                    userHasPermissions.delete || isTechnicalField()
                                      ? styles.dangerColor
                                      : styles.disabledColor
                                  }
                                  style={{ padding: "0px 2px" }}
                                  icon={
                                    <DeleteOutlined
                                      className={
                                        isTechnicalField() || !userHasPermissions.delete
                                          ? styles.disabledColor
                                          : styles.dangerColor
                                      }
                                    />
                                  }
                                >
                                  {t("General.Labels.Delete", {
                                    lngs: i18n.languages,
                                    defaultValue: "Delete",
                                  })}
                                </Button>
                              </Popconfirm>
                            </Tooltip>
                            <Button
                              type={isTechnicalField() ? "default" : "ghost"}
                              onClick={resetField}
                              size="small"
                              icon={<SyncOutlined />}
                              disabled={isTechnicalField()}
                            >
                              {t("General.Labels.Reset", {
                                lngs: i18n.languages,
                                defaultValue: "Reset",
                              })}
                            </Button>
                            <Tooltip
                              title={
                                !userHasPermissions.write
                                  ? "You don't have sufficient permissions to perform this action."
                                  : ""
                              }
                            >
                              <Button
                                className={
                                  updateFieldAllowed ? "update-btn" : ""
                                }
                                disabled={!updateFieldAllowed}
                                onClick={updateField}
                                size="small"
                                icon={<CheckOutlined />}
                                loading={updateFieldLoading}
                              >
                                {t("General.Labels.Update", {
                                  lngs: i18n.languages,
                                  defaultValue: "Update",
                                })}
                              </Button>
                            </Tooltip>
                          </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                          <div>
                            <Form disabled={isTechnicalField()} layout="vertical" size="small">
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldName",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Name:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldName",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                                required={true}
                              >
                                <Input
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  value={selectedField?.name}
                                  maxLength={FIELD_MAX_LENGTH.NAME}
                                  onChange={onSelectedFieldNameChange}
                                />
                              </Form.Item>
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDatatype",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Data type:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDatatype",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                                required={true}
                              >
                                <Select
                                  showSearch={true}
                                  showArrow={true}
                                  allowClear={true}
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  filterSort={(optionA, optionB) =>
                                    (optionA!.label as unknown as string)
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB!.label as unknown as string).toLowerCase()
                                      )
                                  }
                                  value={selectedField?.datatype?.toLowerCase()}
                                  onChange={onSelectedFieldDatatypeChange}
                                  options={DATA_TYPES}
                                  filterOption={(inputValue, option) =>
                                    option!.value
                                      .toLowerCase()
                                      .indexOf(inputValue.toLowerCase()) !== -1
                                  }
                                ></Select>
                              </Form.Item>
                              {["varchar", "nvarchar"].includes(
                                selectedField?.datatype?.toLowerCase()
                              ) && (
                                  <Form.Item
                                    label={t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldMaxLength",
                                      {
                                        lngs: i18n.languages,
                                        defaultValue: "Max length:",
                                      }
                                    )}
                                    tooltip={t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldMaxLength",
                                      { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                  >
                                    <InputNumber
                                      style={{ width: "100%" }}
                                      placeholder={
                                        t("General.Placeholders.EnterValue", {
                                          lngs: i18n.languages,
                                          defaultValue: "Enter value",
                                        })!
                                      }
                                      size="small"
                                      min={1}
                                      max={
                                        selectedField?.datatype?.toLowerCase() === "varchar"
                                          ? FIELD_MAX_LENGTH.TYPE_VARCHAR
                                          : FIELD_MAX_LENGTH.TYPE_NVARCHAR
                                      }
                                      defaultValue={500}
                                      value={selectedField?.maxLength}
                                      onChange={onSelectedFieldMaxLengthChange}
                                      onFocus={() => setValidateMaxLength(true)}
                                      onBlur={() => setValidateMaxLength(false)}
                                    />
                                    {
                                      validateMaxLength &&
                                      selectedField?.datatype?.toLowerCase() === "varchar" &&
                                      selectedField?.maxLength === FIELD_MAX_LENGTH.TYPE_VARCHAR && (
                                        <span className="validation-warning-text">
                                          {t("General.Validations.MaximumLengthReached", {
                                            lngs: i18n.languages,
                                            defaultValue: "Maximum length has been reached.",
                                          })!} ({FIELD_MAX_LENGTH.TYPE_VARCHAR})
                                        </span>
                                      )}
                                    {
                                      validateMaxLength &&
                                      selectedField?.datatype?.toLowerCase() === "nvarchar" &&
                                      selectedField?.maxLength === FIELD_MAX_LENGTH.TYPE_NVARCHAR && (
                                        <span className="validation-warning-text">
                                          {t("General.Validations.MaximumLengthReached", {
                                            lngs: i18n.languages,
                                            defaultValue: "Maximum length has been reached.",
                                          })!} ({FIELD_MAX_LENGTH.TYPE_NVARCHAR})
                                        </span>
                                      )}
                                  </Form.Item>
                                )}
                              {["decimal", "numeric"].includes(
                                selectedField?.datatype?.toLowerCase()
                              ) && (
                                  <>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldPrecision",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Precision:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldPrecision",
                                        { lngs: i18n.languages, defaultValue: "" }
                                      )}
                                      required
                                    >
                                      <InputNumber
                                        style={{ width: "100%" }}
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        size="small"
                                        min={1}
                                        max={32}
                                        value={selectedField?.precision}
                                        onChange={onSelectedFieldPrecisionChange}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldScale",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Scale:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldScale",
                                        { lngs: i18n.languages, defaultValue: "" }
                                      )}
                                      required
                                    >
                                      <InputNumber
                                        style={{ width: "100%" }}
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        size="small"
                                        min={1}
                                        max={12}
                                        value={selectedField?.scale}
                                        onChange={onSelectedFieldScaleChange}
                                      />
                                    </Form.Item>
                                  </>
                                )}
                              {selectedOperation === OPERATIONS.LEGACY && (
                                <Form.Item
                                  label={t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDeltaCollection",
                                    {
                                      lngs: i18n.languages,
                                      defaultValue: "Delta collection:",
                                    }
                                  )}
                                  tooltip={t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDeltaCollection",
                                    { lngs: i18n.languages, defaultValue: "" }
                                  )}
                                >
                                  <Input
                                    placeholder={
                                      t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                      })!
                                    }
                                    value={selectedField?.deltaCollection}
                                    onChange={
                                      onSelectedFieldDeltaCollectionChange
                                    }
                                    onBlur={onSelectedFieldDeltaCollectionBlur}
                                    maxLength={FIELD_MAX_LENGTH.DELTA_COLLECTION}
                                  />
                                </Form.Item>
                              )}
                              {(selectedOperation === OPERATIONS.VALIDATION ||
                                selectedOperation === OPERATIONS.LOADFILE) && (
                                  <Checkbox
                                    checked={selectedField?.isTruncate}
                                    onChange={onSelectedFieldIsTruncateChange}
                                    style={{ marginLeft: 0 }}
                                  >
                                    {t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldTrimValues",
                                      {
                                        lngs: i18n.languages,
                                        defaultValue:
                                          "Trim values if max length is exceeded",
                                      }
                                    )}
                                  </Checkbox>
                                )}
                              <Checkbox
                                checked={selectedField?.isMandatory}
                                onChange={onSelectedFieldIsMandatoryChange}
                                style={{ marginLeft: 0 }}
                              >
                                {t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldMandatory",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Mandatory",
                                  }
                                )}
                              </Checkbox>
                              {selectedOperation === OPERATIONS.IMPORT && (
                                <Checkbox
                                  checked={selectedField?.isKey}
                                  onChange={onSelectedFieldIsKeyChange}
                                  style={{ marginLeft: 0 }}
                                  disabled
                                >
                                  {t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.isKey",
                                    {
                                      lngs: i18n.languages,
                                      defaultValue: "isKey",
                                    }
                                  )}
                                </Checkbox>
                              )}
                              {selectedOperation === OPERATIONS.VALIDATION &&
                                additionalOptionsVisible && (
                                  <>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDatatypeOverride",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Data type override:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDatatypeOverride",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "",
                                        }
                                      )}
                                    >
                                      <Select
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        value={selectedField?.datatypeOverride?.toLowerCase()}
                                        onChange={
                                          onSelectedFieldDatatypeOverrideChange
                                        }
                                        filterSort={(optionA, optionB) =>
                                          (optionA!.label as unknown as string)
                                            .toLowerCase()
                                            .localeCompare(
                                              (optionB!.label as unknown as string).toLowerCase()
                                            )
                                        }
                                        options={DATA_TYPES}
                                        filterOption={(inputValue, option) =>
                                          option!.value
                                            .toUpperCase()
                                            .indexOf(
                                              inputValue.toUpperCase()
                                            ) !== -1
                                        }
                                      ></Select>
                                    </Form.Item>
                                    {(selectedField?.datatypeOverride?.toLowerCase() ==
                                      "nvarchar" ||
                                      selectedField?.datatypeOverride?.toLowerCase() ==
                                      "varchar") && (
                                        <Form.Item
                                          label={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldMaxLengthOverride",
                                            {
                                              lngs: i18n.languages,
                                              defaultValue:
                                                "Max Length override:",
                                            }
                                          )}
                                          tooltip={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldMaxLengthOverride",
                                            {
                                              lngs: i18n.languages,
                                              defaultValue: "",
                                            }
                                          )}
                                        >
                                          <Input
                                            placeholder={
                                              t(
                                                "General.Placeholders.EnterValue",
                                                {
                                                  lngs: i18n.languages,
                                                  defaultValue: "Enter Value",
                                                }
                                              )!
                                            }
                                            value={selectedField?.maxLengthOverride}
                                            onChange={onFieldMaxLengthOverrideChange}
                                            onFocus={() => setValidateMaxLengthOverride(true)}
                                            onBlur={() => setValidateMaxLengthOverride(false)}
                                            max={
                                              selectedField?.datatypeOverride?.toLowerCase() ===
                                                "varchar"
                                                ? FIELD_MAX_LENGTH.TYPE_VARCHAR
                                                : FIELD_MAX_LENGTH.TYPE_NVARCHAR
                                            }
                                          />
                                          {
                                            validateMaxLengthOverride &&
                                            selectedField?.datatypeOverride?.toLowerCase() === "varchar" &&
                                            selectedField?.maxLengthOverride === FIELD_MAX_LENGTH.TYPE_VARCHAR && (
                                              <span className="validation-warning-text">
                                                {t("General.Validations.MaximumLengthReached", {
                                                  lngs: i18n.languages,
                                                  defaultValue: "Maximum length has been reached.",
                                                })!} ({FIELD_MAX_LENGTH.TYPE_VARCHAR})
                                              </span>
                                            )
                                          }
                                          {
                                            validateMaxLengthOverride &&
                                            selectedField?.datatypeOverride?.toLowerCase() === "nvarchar" &&
                                            selectedField?.maxLengthOverride === FIELD_MAX_LENGTH.TYPE_NVARCHAR && (
                                              <span className="validation-warning-text">
                                                {t("General.Validations.MaximumLengthReached", {
                                                  lngs: i18n.languages,
                                                  defaultValue: "Maximum length has been reached.",
                                                })!} ({FIELD_MAX_LENGTH.TYPE_NVARCHAR})
                                              </span>
                                            )
                                          }
                                        </Form.Item>
                                      )}
                                    {(selectedField?.datatypeOverride?.toLowerCase() ===
                                      "decimal" ||
                                      selectedField?.datatypeOverride?.toLowerCase() ===
                                      "numeric") && (
                                        <>
                                          <Form.Item
                                            label={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldPrecision",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "Precision:",
                                              }
                                            )}
                                            tooltip={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldPrecision",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "",
                                              }
                                            )}
                                          >
                                            <InputNumber
                                              placeholder={
                                                t(
                                                  "General.Placeholders.EnterValue",
                                                  {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                  }
                                                )!
                                              }
                                              value={
                                                selectedField?.precisionOverride
                                              }
                                              max={32}
                                              onChange={onFieldPrecisionChange}
                                            />
                                          </Form.Item>
                                          <Form.Item
                                            label={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldScale",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "Scale:",
                                              }
                                            )}
                                            tooltip={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldScale",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "",
                                              }
                                            )}
                                          >
                                            <InputNumber
                                              placeholder={
                                                t(
                                                  "General.Placeholders.EnterValue",
                                                  {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                  }
                                                )!
                                              }
                                              value={selectedField?.scaleOverride}
                                              max={12}
                                              onChange={onFieldScaleChange}
                                            />
                                          </Form.Item>
                                        </>
                                      )}
                                  </>
                                )}
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDescription",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Description:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDescription",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                              >
                                <TextArea
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  rows={selectedOperation === OPERATIONS.IMPORT ? 5 : 6}
                                  allowClear
                                  value={selectedField?.description}
                                  onChange={onSelectedFieldDescriptionChange}
                                  onFocus={() => setValidateDescription(true)}
                                  onBlur={() => setValidateDescription(false)}
                                  maxLength={FIELD_MAX_LENGTH.DESCRIPTION}
                                />
                                {
                                  validateDescription &&
                                  selectedField?.description?.length === FIELD_MAX_LENGTH.DESCRIPTION && (
                                    <span className="validation-warning-text">
                                      {t("General.Validations.MaximumCharAmountReached", {
                                        lngs: i18n.languages,
                                        defaultValue: "Maximum amount of characters has been reached.",
                                      })!} ({FIELD_MAX_LENGTH.DESCRIPTION})
                                    </span>
                                  )}
                              </Form.Item>
                            </Form>
                          </div>
                          <div>
                            <Form disabled={isTechnicalField()} layout="vertical" size="small">
                              {selectedOperation === OPERATIONS.VALIDATION && (
                                <>
                                  <Form.Item
                                    label={t("Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldOwner", {
                                      lngs: i18n.languages,
                                      defaultValue: "Owner:",
                                    })}
                                  >
                                    <Input
                                      placeholder={t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                      })!}
                                      value={selectedField?.owner}
                                      onChange={onSelectedFieldOwnerChange}
                                      maxLength={FIELD_MAX_LENGTH.LABEL}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t("Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldWhoToSolve", {
                                      lngs: i18n.languages,
                                      defaultValue: "Who To Solve:",
                                    })}
                                  >
                                    <Input
                                      placeholder={t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                      })!}
                                      value={selectedField?.whoToSolve}
                                      onChange={onSelectedFieldWhoToSolveChange}
                                      maxLength={FIELD_MAX_LENGTH.LABEL}
                                    />
                                  </Form.Item>
                                </>
                              )}
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldLabel",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Label:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldLabel",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                              >
                                <Input
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  value={selectedField?.label}
                                  onChange={onSelectedFieldLabelChange}
                                  maxLength={FIELD_MAX_LENGTH.LABEL}
                                />
                              </Form.Item>
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldType",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Type:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldType",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                              >
                                <Select
                                  showSearch={true}
                                  showArrow={true}
                                  allowClear={true}
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  value={selectedField?.typeId}
                                  onChange={onSelectedFieldFieldLabelChange}
                                  filterSort={(optionA, optionB) =>
                                    (optionA!.label as unknown as string)
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB!.label as unknown as string).toLowerCase()
                                      )
                                  }
                                  options={fieldTypes.map((x: any) => ({
                                    label: x.name,
                                    value: x.id,
                                  }))}
                                  optionFilterProp="children"
                                  filterOption={(inputValue: any, option: any) =>
                                    option!.label
                                      .toUpperCase()
                                      .indexOf(
                                        inputValue.toUpperCase()
                                      ) !== -1
                                  }
                                >
                                  {fieldTypes.map((item: any) => {
                                    return (
                                      <Option value={item.id}>
                                        {item.name}
                                      </Option>
                                    );
                                  })}
                                </Select>
                                {dependentType &&  (
                                  <Form.Item
                                    label={dependentType?.name}
                                    tooltip={t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.DependentType",
                                      { lngs: i18n.languages, defaultValue: "Select the dependent column for this field" }
                                    )}
                                    rules={[
                                      {
                                        required: true,
                                        message: t("General.Validation.Required", {
                                          lngs: i18n.languages,
                                          defaultValue: `${dependentType?.name} is required`,
                                        }),
                                      },
                                    ]}
                                    required={true}
                                  >
                                    <Select
                                      placeholder={t("General.Placeholders.SelectOption", {
                                        lngs: i18n.languages,
                                        defaultValue: "Select option",
                                      })}
                                      value={selectedField?.subtypeCountryFieldId}
                                      onChange={onSelectedCountryColumnChange}
                                      showSearch={true}
                                      showArrow={true}
                                      allowClear={true}
                                      options={dependentColumns}
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        (option!.label as string).toLowerCase().includes(input.toLowerCase())
                                      }
                                    />
                                  </Form.Item>
                                )}
                                {formatOptions.length > 0 && selectedField?.typeId && (
                                  <Form.Item
                                    label={t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.Format",
                                      {
                                        lngs: i18n.languages,
                                        defaultValue: "Format:",
                                      }
                                    )}
                                    rules={[
                                      {
                                        required: true,
                                        message: t("General.Validation.Required", {
                                          lngs: i18n.languages,
                                          defaultValue: "Format is required",
                                        }),
                                      },
                                    ]}
                                    tooltip={t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.Format",
                                      { lngs: i18n.languages, defaultValue: "Select the format for this field" }
                                    )}
                                    required={true}
                                  >
                                    <Select
                                      placeholder={t("General.Placeholders.SelectFormat", {
                                        lngs: i18n.languages,
                                        defaultValue: "Select format",
                                      })}
                                      value={selectedField?.subtypeFormatId || null}
                                      onChange={onSelectedFormatChange}
                                      showSearch={true}
                                      showArrow={true}
                                      allowClear={true}
                                      options={formatOptions}
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        (option!.label as string).toLowerCase().includes(input.toLowerCase())
                                      }
                                      filterSort={(optionA, optionB) =>
                                          optionA.label! < optionB.label! ? -1 : 1
                                      }
                                    />
                                  </Form.Item>
                                )}

                              </Form.Item>
                              {(fieldTypes.find(x => x.id == selectedField?.typeId)?.name == "ReferenceList" ||
                                fieldTypes.find(x => x.id == selectedField?.typeId)?.name == "Reference") && (
                                  <>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ReferenceListType",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Reference list type:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.ReferenceListType",
                                        { lngs: i18n.languages, defaultValue: "" }
                                      )}
                                    >
                                      <Select
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        value={selectedField?.referenceListType}
                                        onChange={onSelectedFieldReferenceListTypeChange}
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        options={
                                          [
                                            { label: "Filter Validation Type", value: "filter-validation" },
                                            { label: "Custom Query", value: "custom-query" }
                                          ]
                                        }
                                        optionFilterProp="children"
                                        filterOption={(inputValue, option) =>
                                          (option!.value as string)
                                            .toUpperCase()
                                            .indexOf(
                                              inputValue.toUpperCase()
                                            ) !== -1
                                        }
                                      >
                                      </Select>
                                    </Form.Item>
                                    {selectedField?.referenceListType === "custom-query" && (
                                      <Form.Item
                                        label={t(
                                          "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.CustomQuery",
                                          {
                                            lngs: i18n.languages,
                                            defaultValue: "Custom Query:",
                                          }
                                        )}
                                        tooltip={t(
                                          "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.CustomQuery",
                                          { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                      >
                                        <TextArea
                                          placeholder={t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!}
                                          rows={6}
                                          allowClear
                                          value={selectedField?.referenceListValue}
                                          onChange={onSelectedFieldCustomQueryChange}
                                        />
                                      </Form.Item>

                                    )}
                                    {selectedField?.referenceListType === "filter-validation" && (
                                      <>
                                        <Form.Item
                                          label={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ReferenceListValue",
                                            {
                                              lngs: i18n.languages,
                                              defaultValue: "Reference list value:",
                                            }
                                          )}
                                          tooltip={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.ReferenceListValue",
                                            { lngs: i18n.languages, defaultValue: "" }
                                          )}
                                        >
                                          <Select
                                            placeholder={
                                              t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                              })!
                                            }
                                            value={selectedField?.referenceListValue}
                                            onChange={onSelectedFieldReferenceListValueChange}
                                            showSearch={true}
                                            showArrow={true}
                                            allowClear={true}
                                            options={referenceValidationTypes.map((x: any) => ({
                                              label: x,
                                              value: x,
                                            }))}
                                            optionFilterProp="children"
                                            filterOption={(inputValue, option) =>
                                              (option!.value as string)
                                                .toUpperCase()
                                                .indexOf(
                                                  inputValue.toUpperCase()
                                                ) !== -1
                                            }
                                          >
                                          </Select>
                                        </Form.Item>
                                        <Form.Item>
                                          <Checkbox
                                            checked={selectedField?.referenceListValueCanUserAdd}
                                            onChange={onSelectedFieldReferenceListValueCanUserAddChange}
                                            style={{ marginLeft: 0 }}
                                          >
                                            {t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ReferenceListValueCanAdd",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                  "Can user add custom values",
                                              }
                                            )}
                                          </Checkbox>
                                        </Form.Item>
                                      </>
                                    )}
                                  </>
                                )}
                            </Form>
                          </div>
                        </div>
                      </div>
                    )}
                  {selectedTable &&
                    selectedTable.id !== "New table" &&
                    selectedField &&
                    selectedField.id === "New field" && (
                      <div>
                        <div className="title-actions">
                          <Breadcrumb>
                            <Breadcrumb.Item>
                              {t(
                                "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.NewField",
                                {
                                  lngs: i18n.languages,
                                  defaultValue: "New field",
                                }
                              )}
                            </Breadcrumb.Item>
                          </Breadcrumb>
                          <div className="action-buttons">
                            {selectedOperation === OPERATIONS.VALIDATION && (
                              <Button
                                type="ghost"
                                // disabled={updateFieldAllowed}
                                onClick={showAdditionalOptions}
                                size="small"
                                // icon={<CheckOutlined />}
                                loading={updateFieldLoading}
                              >
                                {t("General.Labels.AdvancedOptions", {
                                  lngs: i18n.languages,
                                  defaultValue: "Advanced Options",
                                })}
                              </Button>
                            )}
                            <Button
                              type="ghost"
                              size="small"
                              onClick={resetField}
                              icon={<SyncOutlined />}
                            >
                              {t("General.Labels.Reset", {
                                lngs: i18n.languages,
                                defaultValue: "Reset",
                              })}
                            </Button>
                            <Tooltip
                              title={
                                !userHasPermissions.write
                                  ? "You don't have sufficient permissions to perform this action."
                                  : ""
                              }
                            >
                              <Button
                                className={
                                  updateFieldAllowed ? "update-btn" : ""
                                }
                                disabled={!updateFieldAllowed}
                                onClick={createField}
                                size="small"
                                icon={<CheckOutlined />}
                                loading={updateFieldLoading}
                              >
                                {t("General.Labels.Create", {
                                  lngs: i18n.languages,
                                  defaultValue: "Create",
                                })}
                              </Button>
                            </Tooltip>
                          </div>
                        </div>
                        <Divider />
                        <div className="form-content">
                          <div>
                            <Form layout="vertical" size="small">
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldName",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Name:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldName",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                                required={true}
                              >
                                <Input
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  value={selectedField?.name}
                                  maxLength={FIELD_MAX_LENGTH.NAME}
                                  onChange={onSelectedFieldNameChange}
                                />
                              </Form.Item>
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDatatype",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Data type:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDatatype",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                                required={true}
                              >
                                <Select
                                  showSearch={true}
                                  showArrow={true}
                                  allowClear={true}
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  value={selectedField?.datatype}
                                  onChange={onSelectedFieldDatatypeChange}
                                  options={DATA_TYPES}
                                  filterOption={(inputValue, option) =>
                                    option!.value
                                      .toUpperCase()
                                      .indexOf(inputValue.toUpperCase()) !== -1
                                  }
                                ></Select>
                              </Form.Item>
                              {["varchar", "nvarchar"].includes(
                                selectedField?.datatype?.toLowerCase()
                              ) && (
                                  <Form.Item
                                    label={t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldMaxLength",
                                      {
                                        lngs: i18n.languages,
                                        defaultValue: "Max length:",
                                      }
                                    )}
                                    tooltip={t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldMaxLength",
                                      { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                  >
                                    <InputNumber
                                      style={{ width: "100%" }}
                                      size="small"
                                      min={1}
                                      max={
                                        selectedField?.datatype?.toLowerCase() === "varchar"
                                          ? FIELD_MAX_LENGTH.TYPE_VARCHAR
                                          : FIELD_MAX_LENGTH.TYPE_NVARCHAR
                                      }
                                      defaultValue={500}
                                      value={selectedField?.maxLength}
                                      onChange={onSelectedFieldMaxLengthChange}
                                      onFocus={() => setValidateMaxLength(true)}
                                      onBlur={() => setValidateMaxLength(false)}
                                    />
                                    {
                                      validateMaxLength &&
                                      selectedField?.datatype?.toLowerCase() === "varchar" &&
                                      selectedField?.maxLength === FIELD_MAX_LENGTH.TYPE_VARCHAR && (
                                        <span className="validation-warning-text">
                                          {t("General.Validations.MaximumLengthReached", {
                                            lngs: i18n.languages,
                                            defaultValue: "Maximum length has been reached.",
                                          })!} ({FIELD_MAX_LENGTH.TYPE_VARCHAR})
                                        </span>
                                      )
                                    }
                                    {
                                      validateMaxLength &&
                                      selectedField?.datatype?.toLowerCase() === "nvarchar" &&
                                      selectedField?.maxLength === FIELD_MAX_LENGTH.TYPE_NVARCHAR && (
                                        <span className="validation-warning-text">
                                          {t("General.Validations.MaximumLengthReached", {
                                            lngs: i18n.languages,
                                            defaultValue: "Maximum length has been reached.",
                                          })!} ({FIELD_MAX_LENGTH.TYPE_NVARCHAR})
                                        </span>
                                      )
                                    }
                                  </Form.Item>
                                )}
                              {["decimal", "numeric"].includes(
                                selectedField?.datatype?.toLowerCase()
                              ) && (
                                  <>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldPrecision",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Precision:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldPrecision",
                                        { lngs: i18n.languages, defaultValue: "" }
                                      )}
                                      required
                                    >
                                      <InputNumber
                                        style={{ width: "100%" }}
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        size="small"
                                        min={1}
                                        max={32}
                                        value={selectedField?.precision}
                                        onChange={onSelectedFieldPrecisionChange}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldScale",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Scale:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldScale",
                                        { lngs: i18n.languages, defaultValue: "" }
                                      )}
                                      required
                                    >
                                      <InputNumber
                                        style={{ width: "100%" }}
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        size="small"
                                        min={1}
                                        max={12}
                                        value={selectedField?.scale}
                                        onChange={onSelectedFieldScaleChange}
                                      />
                                    </Form.Item>
                                  </>
                                )}
                              {selectedOperation === OPERATIONS.LEGACY && (
                                <Form.Item
                                  label={t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDeltaCollection",
                                    {
                                      lngs: i18n.languages,
                                      defaultValue: "Delta collection:",
                                    }
                                  )}
                                  tooltip={t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDeltaCollection",
                                    { lngs: i18n.languages, defaultValue: "" }
                                  )}
                                >
                                  <Input
                                    placeholder={
                                      t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                      })!
                                    }
                                    value={selectedField?.deltaCollection}
                                    onChange={
                                      onSelectedFieldDeltaCollectionChange
                                    }
                                    maxLength={FIELD_MAX_LENGTH.DELTA_COLLECTION}
                                  />
                                </Form.Item>
                              )}
                              {(selectedOperation === OPERATIONS.VALIDATION ||
                                selectedOperation === OPERATIONS.LOADFILE) && (
                                  <Checkbox
                                    checked={selectedField?.isTruncate}
                                    onChange={onSelectedFieldIsTruncateChange}
                                    style={{ marginLeft: 0 }}
                                  >
                                    {t(
                                      "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldTrimValues",
                                      {
                                        lngs: i18n.languages,
                                        defaultValue:
                                          "Trim values if max length is exceeded",
                                      }
                                    )}
                                  </Checkbox>
                                )}
                              <Checkbox
                                checked={selectedField?.isMandatory}
                                onChange={onSelectedFieldIsMandatoryChange}
                                style={{ marginLeft: 0 }}
                              >
                                {t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldMandatory",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Mandatory",
                                  }
                                )}
                              </Checkbox>
                              {selectedOperation === OPERATIONS.VALIDATION &&
                                additionalOptionsVisible && (
                                  <>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDatatypeOverride",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Data type override:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDatatypeOverride",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "",
                                        }
                                      )}
                                    >
                                      <Select
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        value={selectedField?.datatypeOverride?.toLowerCase()}
                                        onChange={
                                          onSelectedFieldDatatypeOverrideChange
                                        }
                                        options={DATA_TYPES}
                                        filterOption={(inputValue, option) =>
                                          option!.value
                                            .toUpperCase()
                                            .indexOf(
                                              inputValue.toUpperCase()
                                            ) !== -1
                                        }
                                      ></Select>
                                    </Form.Item>
                                    {(selectedField?.datatypeOverride?.toLowerCase() ==
                                      "nvarchar" ||
                                      selectedField?.datatypeOverride?.toLowerCase() ==
                                      "varchar") && (
                                        <Form.Item
                                          label={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldMaxLengthOverride",
                                            {
                                              lngs: i18n.languages,
                                              defaultValue:
                                                "Max Length override:",
                                            }
                                          )}
                                          tooltip={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldMaxLengthOverride",
                                            {
                                              lngs: i18n.languages,
                                              defaultValue: "",
                                            }
                                          )}
                                        >
                                          <Input
                                            placeholder={
                                              t(
                                                "General.Placeholders.FieldMaxLengthOverride",
                                                {
                                                  lngs: i18n.languages,
                                                  defaultValue: "Enter value",
                                                }
                                              )!
                                            }
                                            value={selectedField?.maxLengthOverride}
                                            onChange={onFieldMaxLengthOverrideChange}
                                            onFocus={() => setValidateMaxLengthOverride(true)}
                                            onBlur={() => setValidateMaxLengthOverride(false)}
                                            max={
                                              selectedField?.datatypeOverride?.toLowerCase() ===
                                                "varchar"
                                                ? FIELD_MAX_LENGTH.TYPE_VARCHAR
                                                : FIELD_MAX_LENGTH.TYPE_NVARCHAR
                                            }
                                          />
                                          {
                                            validateMaxLengthOverride &&
                                            selectedField?.datatypeOverride?.toLowerCase() === "varchar" &&
                                            selectedField?.maxLengthOverride === FIELD_MAX_LENGTH.TYPE_VARCHAR && (
                                              <span className="validation-warning-text">
                                                {t("General.Validations.MaximumLengthReached", {
                                                  lngs: i18n.languages,
                                                  defaultValue: "Maximum length has been reached.",
                                                })!} ({FIELD_MAX_LENGTH.TYPE_VARCHAR})
                                              </span>
                                            )
                                          }
                                          {
                                            validateMaxLengthOverride &&
                                            selectedField?.datatypeOverride?.toLowerCase() === "nvarchar" &&
                                            selectedField?.maxLengthOverride === FIELD_MAX_LENGTH.TYPE_NVARCHAR && (
                                              <span className="validation-warning-text">
                                                {t("General.Validations.MaximumLengthReached", {
                                                  lngs: i18n.languages,
                                                  defaultValue: "Maximum length has been reached.",
                                                })!} ({FIELD_MAX_LENGTH.TYPE_NVARCHAR})
                                              </span>
                                            )
                                          }
                                        </Form.Item>
                                      )}
                                    {selectedField?.datatypeOverride?.toLowerCase() ===
                                      "decimal" && (
                                        <>
                                          <Form.Item
                                            label={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldPrecision",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "Precision:",
                                              }
                                            )}
                                            tooltip={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldPrecision",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "",
                                              }
                                            )}
                                          >
                                            <InputNumber
                                              placeholder={
                                                t(
                                                  "General.Placeholders.EnterValue",
                                                  {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                  }
                                                )!
                                              }
                                              value={
                                                selectedField?.precisionOverride
                                              }
                                              max={32}
                                              onChange={onFieldPrecisionChange}
                                            />
                                          </Form.Item>
                                          <Form.Item
                                            label={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldScale",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "Scale:",
                                              }
                                            )}
                                            tooltip={t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldScale",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue: "",
                                              }
                                            )}
                                          >
                                            <InputNumber
                                              placeholder={
                                                t(
                                                  "General.Placeholders.EnterValue",
                                                  {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                  }
                                                )!
                                              }
                                              value={selectedField?.scaleOverride}
                                              max={12}
                                              onChange={onFieldScaleChange}
                                            />
                                          </Form.Item>
                                        </>
                                      )}
                                  </>
                                )}
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldDescription",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Description:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldDescription",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                              >
                                <TextArea
                                  // ref={descriptionInputRef}
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  rows={selectedOperation === OPERATIONS.IMPORT ? 5 : 6}
                                  allowClear
                                  value={selectedField?.description}
                                  onChange={onSelectedFieldDescriptionChange}
                                  onFocus={() => setValidateDescription(true)}
                                  onBlur={() => setValidateDescription(false)}
                                  maxLength={FIELD_MAX_LENGTH.DESCRIPTION}
                                />
                                {
                                  validateDescription &&
                                  selectedField?.description?.length === FIELD_MAX_LENGTH.DESCRIPTION && (
                                    <span className="validation-warning-text">
                                      {t("General.Validations.MaximumCharAmountReached", {
                                        lngs: i18n.languages,
                                        defaultValue: "Maximum amount of characters has been reached.",
                                      })!} ({FIELD_MAX_LENGTH.DESCRIPTION})
                                    </span>
                                  )}
                              </Form.Item>
                            </Form>
                          </div>
                          <div>
                            <Form layout="vertical" size="small">
                              {selectedOperation === OPERATIONS.VALIDATION && (
                                <>
                                  <Form.Item
                                    label={t("Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldOwner", {
                                      lngs: i18n.languages,
                                      defaultValue: "Owner:",
                                    })}
                                  >
                                    <Input
                                      placeholder={t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                      })!}
                                      value={selectedField?.owner}
                                      onChange={onSelectedFieldOwnerChange}
                                      maxLength={FIELD_MAX_LENGTH.LABEL}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label={t("Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldWhoToSolve", {
                                      lngs: i18n.languages,
                                      defaultValue: "Who To Solve:",
                                    })}
                                  >
                                    <Input
                                      placeholder={t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                      })!}
                                      value={selectedField?.whoToSolve}
                                      onChange={onSelectedFieldWhoToSolveChange}
                                      maxLength={FIELD_MAX_LENGTH.LABEL}
                                    />
                                  </Form.Item>
                                </>
                              )}
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldLabel",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Label:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldLabel",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                              >
                                <Input
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  value={selectedField?.label}
                                  onChange={onSelectedFieldLabelChange}
                                  maxLength={FIELD_MAX_LENGTH.LABEL}
                                />
                              </Form.Item>
                              <Form.Item
                                label={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.FieldType",
                                  {
                                    lngs: i18n.languages,
                                    defaultValue: "Type:",
                                  }
                                )}
                                tooltip={t(
                                  "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.FieldType",
                                  { lngs: i18n.languages, defaultValue: "" }
                                )}
                              >
                                <Select
                                  placeholder={
                                    t("General.Placeholders.EnterValue", {
                                      lngs: i18n.languages,
                                      defaultValue: "Enter value",
                                    })!
                                  }
                                  value={selectedField?.typeId}
                                  onChange={onSelectedFieldFieldLabelChange}
                                  showSearch={true}
                                  showArrow={true}
                                  allowClear={true}
                                  options={
                                    fieldTypes.map((x: any) => ({
                                      label: x.name,
                                      value: x.id,
                                    }))}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (
                                      option!.label as string
                                    ).toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {fieldTypes.map((item: any) => {
                                    return (
                                      <Option value={item.id}>
                                        {item.name}
                                      </Option>
                                    );
                                  })}
                                </Select>
                              </Form.Item>
                              {dependentType && (
                                <Form.Item
                                  label={dependentType?.name}
                                  tooltip={t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.DependentColumn",
                                    { lngs: i18n.languages, defaultValue: "Select the dependency for this field" }
                                  )}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("General.Validation.Required", {
                                        lngs: i18n.languages,
                                        defaultValue: `${dependentType?.name} is required`,
                                      }),
                                    },
                                  ]}
                                  required={true}
                                >
                                  <Select
                                    placeholder={t("General.Placeholders.SelectOption", {
                                      lngs: i18n.languages,
                                      defaultValue: "Select option",
                                    })}
                                    value={selectedField?.subtypeCountryFieldId}
                                    onChange={onSelectedCountryColumnChange}
                                    showSearch={true}
                                    showArrow={true}
                                    allowClear={true}
                                    options={dependentColumns}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option!.label as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                  />
                                </Form.Item>
                              )}
                              {formatOptions.length > 0 && (
                                <Form.Item
                                  label={t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.Format",
                                    {
                                      lngs: i18n.languages,
                                      defaultValue: "Format:",
                                    }
                                  )}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("General.Validation.Required", {
                                        lngs: i18n.languages,
                                        defaultValue: "Format is required",
                                      }),
                                    },
                                  ]}
                                  tooltip={t(
                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.Format",
                                    { lngs: i18n.languages, defaultValue: "Select the format for this field" }
                                  )}
                                  required={true}
                                >
                                  <Select
                                    placeholder={t("General.Placeholders.SelectFormat", {
                                      lngs: i18n.languages,
                                      defaultValue: "Select format",
                                    })}
                                    value={selectedField?.subtypeFormatId}
                                    onChange={onSelectedFormatChange}
                                    showSearch={true}
                                    showArrow={true}
                                    allowClear={true}
                                    options={formatOptions}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option!.label as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label! < optionB.label! ? -1 : 1
                                    }
                                  />
                                </Form.Item>
                              )}
                              {(fieldTypes.find(x => x.id == selectedField?.typeId)?.name == "ReferenceList" ||
                                fieldTypes.find(x => x.id == selectedField?.typeId)?.name == "Reference") && (
                                  <>
                                    <Form.Item
                                      label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ReferenceListType",
                                        {
                                          lngs: i18n.languages,
                                          defaultValue: "Reference list type:",
                                        }
                                      )}
                                      tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.ReferenceListType",
                                        { lngs: i18n.languages, defaultValue: "" }
                                      )}
                                    >
                                      <Select
                                        placeholder={
                                          t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!
                                        }
                                        value={selectedField?.referenceListType}
                                        onChange={onSelectedFieldReferenceListTypeChange}
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        options={
                                          [
                                            { label: "Filter Validation Type", value: "filter-validation" },
                                            { label: "Custom Query", value: "custom-query" }
                                          ]
                                        }
                                        optionFilterProp="children"
                                        filterOption={(inputValue, option) =>
                                          (option!.value as string)
                                            .toUpperCase()
                                            .indexOf(
                                              inputValue.toUpperCase()
                                            ) !== -1
                                        }
                                      >
                                      </Select>
                                    </Form.Item>

                                    {selectedField?.referenceListType === "custom-query" && (
                                      <Form.Item
                                        label={t(
                                          "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.CustomQuery",
                                          {
                                            lngs: i18n.languages,
                                            defaultValue: "Custom Query:",
                                          }
                                        )}
                                        tooltip={t(
                                          "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.CustomQuery",
                                          { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                      >
                                        <TextArea
                                          placeholder={t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                          })!}
                                          rows={6}
                                          allowClear
                                          value={selectedField?.referenceListValue}
                                          onChange={onSelectedFieldCustomQueryChange}
                                        />
                                      </Form.Item>
                                    )}

                                    {selectedField?.referenceListType === "filter-validation" && (
                                      <>
                                        <Form.Item
                                          label={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ReferenceListValue",
                                            {
                                              lngs: i18n.languages,
                                              defaultValue: "Reference list value:",
                                            }
                                          )}
                                          tooltip={t(
                                            "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.ReferenceListValue",
                                            { lngs: i18n.languages, defaultValue: "" }
                                          )}
                                        >
                                          <Select
                                            placeholder={
                                              t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                              })!
                                            }
                                            value={selectedField?.referenceListValue}
                                            onChange={onSelectedFieldReferenceListValueChange}
                                            showSearch={true}
                                            showArrow={true}
                                            allowClear={true}
                                            options={referenceValidationTypes.map((x: any) => ({
                                              label: x,
                                              value: x,
                                            }))}
                                            optionFilterProp="children"
                                            filterOption={(inputValue, option) =>
                                              (option!.value as string)
                                                .toUpperCase()
                                                .indexOf(
                                                  inputValue.toUpperCase()
                                                ) !== -1
                                            }
                                          >
                                          </Select>
                                        </Form.Item>
                                        <Form.Item>
                                          <Checkbox
                                            checked={selectedField?.referenceListValueCanUserAdd}
                                            onChange={onSelectedFieldReferenceListValueCanUserAddChange}
                                            style={{ marginLeft: 0 }}
                                          >
                                            {t(
                                              "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.ReferenceListValueCanAdd",
                                              {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                  "Can user add custom values",
                                              }
                                            )}
                                          </Checkbox>
                                        </Form.Item>
                                      </>
                                    )}
                                  </>
                                )}
                            </Form>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              ) : (
                <div className="form-containers section-container-lg form-expanded">
                  <Empty
                    description={
                      selectedEntity &&
                      selectedOperation &&
                      !selectedTable &&
                      t("Page.Configuration.TableSetup.Headers.TableSetup", {
                        lngs: i18n.languages,
                        defaultValue: "Please select a table to get started",
                      })
                    }
                  ></Empty>
                </div>
              )}
            </div>
          </TabPane>
          <TabPane
            tab={t("Page.Configuration.TableSetup.Tabs.Translations", {
              lngs: i18n.languages,
              defaultValue: "Translations",
            })}
            key="translations"
          >
            <Translations
              selectedEntity={selectedEntity}
              selectedGroupCode={selectedGroupCode}
              selectedOperation={selectedOperation}
              groupCodes={groupCodes}
              newTranslationDrawerEnabled={newTranslationDrawerEnabled}
              setNewTranslationDrawerEnabled={setNewTranslationDrawerEnabled}
              downloadTranslationDrawerEnabled={
                downloadTranslationDrawerEnabled
              }
              setDownloadTranslationDrawerEnabled={
                setDownloadTranslationDrawerEnabled
              }
              downloadTranslationTemplateDrawerEnabled={
                downloadTranslationTemplateDrawerEnabled
              }
              setDownloadTranslationTemplateDrawerEnabled={
                setDownloadTranslationTemplateDrawerEnabled
              }
              uploadTranslationDrawerEnabled={uploadTranslationDrawerEnabled}
              setUploadTranslationDrawerEnabled={
                setUploadTranslationDrawerEnabled
              }
            />
          </TabPane>
          <TabPane
            tab={t("Page.Configuration.TableSetup.Tabs.References", {
              lngs: i18n.languages,
              defaultValue: "References",
            })}
            key="references"
          >
            <References
              newReferenceDrawerEnabled={newReferenceDrawerEnabled}
              setNewReferenceDrawerEnabled={setNewReferenceDrawerEnabled}
              downloadReferenceDrawerEnabled={downloadReferenceDrawerEnabled}
              setDownloadReferenceDrawerEnabled={
                setDownloadReferenceDrawerEnabled
              }
              downloadReferenceTemplateDrawerEnabled={
                downloadReferenceTemplateDrawerEnabled
              }
              setDownloadReferenceTemplateDrawerEnabled={
                setDownloadReferenceTemplateDrawerEnabled
              }
              uploadReferenceDrawerEnabled={uploadReferenceDrawerEnabled}
              setUploadReferenceDrawerEnabled={setUploadReferenceDrawerEnabled}
            />
          </TabPane>
        </Tabs>
        {showViewDrawer && (
          <Drawer
            height={"95vh"}
            width={"400px"}
            getContainer={false}
            style={{
              position: "absolute",
            }}
            title={t(
              "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.View.Header",
              {
                lngs: i18n.languages,
                defaultValue: "Table view",
              }
            )}
            placement={DRAWER_PLACEMENTS.BOTTOM}
            onClose={onCloseView}
            visible={showViewDrawer}
            closable={false}
            extra={
              <Space>
                <>
                  <Button
                    // onClick={() => showDrawer(RowAction.Edit)}
                    icon={<ExportOutlined />}
                    size="small"
                    onClick={handleViewExportClick}
                  // className={"active-btn"}
                  >
                    {t("General.Labels.Export", {
                      lngs: i18n.languages,
                      defaultValue: "Export",
                    })}
                  </Button>
                  <Button
                    type="ghost"
                    onClick={onCloseView}
                    icon={<CloseOutlined />}
                    size="small"
                  />
                </>
              </Space>
            }
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <Form form={drawerForm} layout="vertical" labelCol={{ span: 12 }}>
                  <Form.Item
                    name="viewDataGroupCode"
                    style={{ width: "200px" }}
                    label={t(
                      "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.View.Labels.GroupCode",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Group code",
                      }
                    )}
                  >
                    <Select
                      placeholder={t("General.Placeholders.SelectOption", {
                        lngs: i18n.languages,
                        defaultValue: "Select option",
                      })}
                      loading={groupCodes.length === 0}
                      onChange={onViewDataGroupCodeChange}
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      disabled={selectedOperation === OPERATIONS.IMPORT}
                      options={groupCodes.map((x: any) => ({
                        label: x.code,
                        value: x.code,
                      }))}
                      filterSort={(optionA, optionB) =>
                        optionA.value! < optionB.value! ? -1 : 1
                      }
                    ></Select>
                  </Form.Item>
                </Form>
                <Form form={drawerForm} layout="vertical" labelCol={{ span: 12 }}>
                  <Form.Item
                    name="viewDataNumberOfRows"
                    style={{ width: "200px" }}
                    label={t(
                      "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.View.Labels.Limit",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Limit:",
                      }
                    )}
                  >
                    <AutoComplete
                      placeholder={t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })}
                      // loading={groupCodes.length == 0}
                      onChange={onSelectedViewDataRowsToShowChange}
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      defaultValue={"100"}
                      value={selectedViewDataRowsToShow}
                      options={[
                        { value: "All", label: "All" },
                        { value: "100", label: "100" },
                        { value: "500", label: "500" },
                      ]}
                    ></AutoComplete>
                  </Form.Item>
                </Form>
              </div>

              <Pagination
                size="small"
                total={tableViewData.length}
                current={viewTablePageIndex}
                pageSize={viewTablePageSize}
                showQuickJumper={true}
                showSizeChanger={true}
                locale={{
                  items_per_page: t("General.Table.Pagination.ItemPerPage", {
                    lngs: i18n.languages,
                    defaultValue: "/page",
                  })!,
                  page: t("General.Table.Pagination.Page", {
                    lngs: i18n.languages,
                    defaultValue: "page",
                  })!,
                  jump_to: t("General.Table.Pagination.GoTo", {
                    lngs: i18n.languages,
                    defaultValue: "Go to",
                  })!,
                }}
                showTotal={(total: number, range: [number, number]) => {
                  const translation = t("General.Table.Pagination.RangeRecords", {
                    lngs: i18n.languages,
                    defaultValue: `${range[0]}-${range[1]} out of ${total} records`,
                  });
                  return `${translation
                    .replace("${range[0]}", range[0].toString())
                    .replace("${range[1]}", range[1].toString())
                    .replace("${total}", total.toString())}`;
                }}
                itemRender={(page: number, type: any, originalElement: any) => {
                  return originalElement;
                }}
                onChange={(page: any, size: any) => {
                  setViewTablePageIndex(page);
                  setViewTablePageSize(size);
                }}
              />
            </div>
            <div>
              <Datatable
                scroll={scrollMain}
                tableColumns={columns}
                data={tableViewData}
                setData={setTableViewData}
                isTableLoading={isTableViewDataLoading}
                otherActions={[]}
                otherRowEnabled={false}
                editRowEnabled={false}
                copyRowEnabled={false}
                deleteRowEnabled={false}
                onEditFunc={undefined}
                onCopyFunc={undefined}
                onDeleteFunc={undefined}
                onDoubleClickRow={undefined}
                selectable={false}
                multiSelect={false}
                selectedRows={undefined}
                setSelectedRows={undefined}
                paginationVisible={false}
                paginationPageIndex={viewTablePageIndex}
                paginationPageSize={viewTablePageSize}
                showActionsColumn={false}
                checkPermissions={true}
              ></Datatable>
            </div>
          </Drawer>
        )}
        {showViewExportDrawer && (
          <Drawer
            width={"400px"}
            getContainer={false}
            style={{
              position: "absolute",
            }}
            title={t("General.Labels.ExportToExcel", {
              lngs: i18n.languages,
              defaultValue: "Export to excel",
            })}
            placement={DRAWER_PLACEMENTS.BOTTOM}
            onClose={onCloseView}
            visible={showViewExportDrawer}
            closable={false}
            extra={
              <Space>
                <>
                  <Button
                    icon={<ExportOutlined />}
                    size="small"
                    className={"active-btn"}
                    loading={downloadLoading}
                    onClick={() => downloadTableViewData()}
                  >
                    {t("General.Labels.Export", {
                      lngs: i18n.languages,
                      defaultValue: "Export",
                    })}
                  </Button>
                  <Button
                    type="ghost"
                    onClick={onCloseViewExport}
                    icon={<CloseOutlined />}
                    size="small"
                  />
                </>
              </Space>
            }
          >
            <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
              <Form form={exportForm} layout="vertical" labelCol={{ span: 12 }}>
                <Form.Item
                  name="exportGroupCode"
                  style={{ width: "300px" }}
                  label={t(
                    "Page.Configuration.TableSetup.Tabs.TableSetup.Drawers.View.Labels.GroupCode",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Group code",
                    }
                  )}
                >
                  <Select
                    placeholder={t("General.Placeholders.SelectOption", {
                      lngs: i18n.languages,
                      defaultValue: "Select option",
                    })}
                    loading={groupCodes.length === 0}
                    onChange={onExportViewDataGroupCodeChange}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    disabled={selectedOperation === OPERATIONS.IMPORT}
                    options={groupCodes.map((x: any) => ({
                      label: x.code,
                      value: x.code,
                    }))}
                    filterSort={(optionA, optionB) =>
                      optionA.value! < optionB.value! ? -1 : 1
                    }
                  ></Select>
                </Form.Item>
              </Form>
              <Form form={exportForm} layout="vertical" labelCol={{ span: 12 }}>
                <Form.Item
                  name="exportNumberOfRows"
                  style={{ width: "300px" }}
                  label="Number of rows:"
                >
                  <AutoComplete
                    placeholder={t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })}
                    // loading={groupCodes.length == 0}
                    onChange={onSelectedExportViewDataRowsToShowChange}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    // defaultValue={"100"}
                    value={selectedExportViewDataRowsToShow}
                    options={[
                      { value: "All", label: "All" },
                      { value: "100", label: "100" },
                      { value: "500", label: "500" },
                    ]}
                  ></AutoComplete>
                </Form.Item>
              </Form>
            </div>
          </Drawer>
        )}
        {showEditFieldsDrawer && (
          <Drawer
            width={"400px"}
            height={"95vh"}
            getContainer={false}
            style={{ position: "absolute", transform: "none" }}
            bodyStyle={{
              display: "flex",
              flexDirection: "column",
              transform: "none",
            }}
            title={t("General.Labels.EditFields", {
              lngs: i18n.languages,
              defaultValue: "Edit Fields",
            })}
            placement={DRAWER_PLACEMENTS.BOTTOM}
            onClose={onCloseRecreateTable}
            visible={showEditFieldsDrawer}
            closable={false}
            extra={
              <Space>
                <>
                  <Button
                    type="ghost"
                    size="small"
                    style={{ padding: "0px 2px" }}
                    icon={<CheckOutlined />}
                    onClick={handleSave}
                    loading={isEditFieldsSaveLoading}
                  >
                    {t("General.Labels.Save", {
                      lngs: i18n.languages,
                      defaultValue: "Save",
                    })}
                  </Button>
                  <Button
                    type="ghost"
                    size="small"
                    style={{ padding: "0px 2px" }}
                    icon={<CheckOutlined />}
                    onClick={handleSaveAndClose}
                    loading={isEditFieldsSaveLoading}
                  >
                    {t("General.Labels.SaveAndClose", {
                      lngs: i18n.languages,
                      defaultValue: "Save & Close",
                    })}
                  </Button>
                  {isEditFieldsDirty ? (
                    <Popconfirm
                      style={{ width: "400px" }}
                      placement="topRight"
                      title={
                        <div
                          style={{
                            width: "400px",
                            wordBreak: "break-word",
                          }}
                        >
                          {t(
                            "Page.Configuration.TableSetup.Tabs.TableSetup.Popups.CancelRecreateTable",
                            {
                              lngs: i18n.languages,
                              defaultValue:
                                "Are you really sure that you want to close edit fields dialog? All of your progress made will be lost.",
                            }
                          )}
                        </div>
                      }
                      icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                      visible={recreateTablePopConfirmOpen}
                      onVisibleChange={handleOpenRecreateTablePopConfirm}
                      onConfirm={() => handleRecreateTableClose()}
                      okText={t("General.Actions.Yes", {
                        lngs: i18n.languages,
                        defaultValue: "Yes",
                      })}
                      cancelText={t("General.Actions.No", {
                        lngs: i18n.languages,
                        defaultValue: "No",
                      })}
                    >
                      <Button
                        type="ghost"
                        size="small"
                        style={{ padding: "0px 2px" }}
                        icon={<CloseOutlined />}
                        loading={isEditFieldsSaveLoading}
                      >
                        {t("General.Labels.Close", {
                          lngs: i18n.languages,
                          defaultValue: "Close",
                        })}
                      </Button>
                    </Popconfirm>
                  ) : (
                    <Button
                      type="ghost"
                      size="small"
                      style={{ padding: "0px 2px" }}
                      icon={<CloseOutlined />}
                      loading={isEditFieldsSaveLoading}
                      onClick={() => handleRecreateTableClose()}
                    >
                      {t("General.Labels.Close", {
                        lngs: i18n.languages,
                        defaultValue: "Close",
                      })}
                    </Button>
                  )}
                  <Dropdown overlay={dropdownMenuRecreateTableActions}>
                    <Button
                      style={{ padding: "0px 2px" }}
                      size="small"
                      type="ghost"
                      icon={<MoreOutlined />}
                      loading={isEditFieldsSaveLoading}
                    >
                      <Space>Actions</Space>
                    </Button>
                  </Dropdown>
                </>
              </Space>
            }
          >
            <div>
              <EditableTable
                fieldTypes={fieldTypes}
                fieldSubTypes={fieldSubtypes}
                dataSource={recreateTableDataSource}
                setDataSource={setRecreateTableDataSource}
                selectedEntity={selectedRecreateTableEntity}
                selectedOperation={selectedRecreateTableOperation}
                selectedDatabase={recreateTableDatabase}
                selectedSchema={recreateTableSchema}
                handleClose={onCloseRecreateTable}
                downloadRecreateTableAsExcelDrawerEnabled={
                  downloadRecreateTableAsExcelDrawerEnabled
                }
                setDownloadRecreateTableAsExcelDrawerEnabled={
                  setDownloadDownloadRecreateTableAsExcelDrawerEnabled
                }
                downloadRecreateTableAsEmptyExcelDrawerEnabled={
                  downloadRecreateTableAsEmptyExcelDrawerEnabled
                }
                setDownloadRecreateTableAsEmptyExcelDrawerEnabled={
                  setDownloadDownloadRecreateTableAsEmptyExcelDrawerEnabled
                }
                uploadRecreateTableFromExcelDrawerEnabled={
                  uploadRecreateTableFromExcelDrawerEnabled
                }
                setUploadRecreateTableFromExcelDrawerEnabled={
                  setUploadRecreateTableFromExcelDrawerEnabled
                }
                uploadRecreateTableFromTableDrawerEnabled={
                  uploadRecreateTableFromTableDrawerEnabled
                }
                setUploadRecreateTableFromTableDrawerEnabled={
                  setUploadRecreateTableFromTableDrawerEnabled
                }
                recreateTableSaveTriggered={recreateTableSaveTriggered}
                setRecreateTableSaveTriggered={setRecreateTableSaveTriggered}
                recreateTableSaveAndCloseTriggered={
                  recreateTableSaveAndCloseTriggered
                }
                setRecreateTableSaveAndCloseTriggered={
                  setRecreateTableSaveAndCloseTriggered
                }
                recreateTableName={recreateTableName}
                recreateTableFields={recreateTableFields}
                entities={entities}
                operations={operations}
                selectedTable={selectedTable}
                isEditFieldsSaveLoading={isEditFieldsSaveLoading}
                setIsEditFieldsSaveLoading={setIsEditFieldsSaveLoading}
                isCheckboxChanged={isCheckboxChanged}
                setIsCheckboxChanged={setIsCheckboxChanged}
                sourceKeys={sourceKeys}
                setSourceKeys={setSourceKeys}
                isDirty={isEditFieldsDirty}
                setIsDirty={setIsEditFieldsDirty}
              />
            </div>
          </Drawer>
        )}
      </div>
    </div>
  );
};

export default TableSetup;
